webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/object.js
var object = __webpack_require__("/CDJ");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/lodash.startcase/index.js
var lodash_startcase = __webpack_require__("peot");
var lodash_startcase_default = /*#__PURE__*/__webpack_require__.n(lodash_startcase);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/table/table.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function table_toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return Object(object["e" /* keys */])(v).map(function (k) {
      return table_toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return table_toString(Object(object["e" /* keys */])(obj).reduce(function (o, k) {
    // Ignore fields that start with _
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return table_toString(a[sortBy]).localeCompare(table_toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    // Label shortcut
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    // Formatter shortcut
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object') {
    field = Object(object["a" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key
    field = { key: key };
  }
  return field;
}

/* harmony default export */ var table = ({
  mixins: [mixins["j" /* listenOnRootMixin */]],
  render: function render(h) {
    var t = this;
    var $slots = t.$slots;
    var $scoped = t.$scopedSlots;
    var fields = t.computedFields;
    var items = t.computedItems;

    // Build the caption
    var caption = h(false);
    if (t.caption || $slots['table-caption']) {
      var data = { style: t.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: t.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    // Build the colgroup
    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    // Build the thead
    var ths = fields.map(function (field) {
      var data = {
        key: field.key,
        class: t.fieldClasses(field),
        style: field.thStyle || {},
        attrs: {
          'tabindex': field.sortable ? '0' : null,
          'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
          'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
        },
        on: {
          click: function click(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            t.headClicked(evt, field);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === utils["a" /* KeyCodes */].ENTER || keyCode === utils["a" /* KeyCodes */].SPACE) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            }
          }
        }
      };
      var slot = $scoped['HEAD_' + field.key];
      if (slot) {
        slot = slot({ label: field.label, column: field.key, field: field });
      } else {
        data.domProps = { innerHTML: field.label };
      }
      return h('th', data, slot);
    });
    var thead = h('thead', { class: t.headClasses }, [h('tr', {}, ths)]);

    // Build the tfoot
    var tfoot = h(false);
    if (t.footClone) {
      var _ths = fields.map(function (field) {
        var data = {
          key: field.key,
          class: t.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            'tabindex': field.sortable ? '0' : null,
            'aria-label': field.sortable ? t.localSortDesc && t.localSortBy === field.key ? t.labelSortAsc : t.labelSortDesc : null,
            'aria-sort': field.sortable && t.localSortBy === field.key ? t.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              t.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === utils["a" /* KeyCodes */].ENTER || keyCode === utils["a" /* KeyCodes */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                t.headClicked(evt, field);
              }
            }
          }
        };
        var slot = $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
      tfoot = h('tfoot', { class: t.footClasses }, [h('tr', {}, _ths)]);
    }

    var rows = [];

    // Add static Top Row slot
    if ($scoped['top-row']) {
      rows.push(h('tr', {}, [$scoped['top-row']({ coloumns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Add the body rows
    items.forEach(function (item, index) {
      var detailsSlot = $scoped['row-details'];
      // For Each Row
      var tds = fields.map(function (field) {
        // Foe Each field in the row
        var data = {
          key: field.key,
          class: t.tdClasses(field, item),
          attrs: field.tdAttr || {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: index,
            unformatted: item[field.key],
            value: t.getFormattedValue(item, field)
          })];
        } else {
          data.domProps = { innerHTML: t.getFormattedValue(item, field) };
        }
        return h('td', data, childNodes);
      });
      // Assemble and add the row
      rows.push(h('tr', {
        key: index,
        class: [t.rowClasses(item), item._showDetails && detailsSlot ? 'b-table-has-details' : ''],
        on: {
          click: function click(evt) {
            t.rowClicked(evt, item, index);
          },
          dblclick: function dblclick(evt) {
            t.rowDblClicked(evt, item, index);
          },
          mouseenter: function mouseenter(evt) {
            t.rowHovered(evt, item, index);
          }
        }
      }, tds));
      // Row Details slot
      if (item._showDetails && detailsSlot) {
        var details = h('td', { attrs: { colspan: String(fields.length) } }, [detailsSlot({ item: item, index: index, fields: fields })]);
        rows.push(h('tr', { key: index + '-details', class: ['b-table-details'] }, [details]));
      } else {
        rows.push(h(false));
      }
    });

    // Empty Items / Empty Filtered Row slot
    if (t.showEmpty && (!items || items.length === 0)) {
      var inner = t.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!inner) {
        inner = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: t.filter ? t.emptyFilteredText : t.emptyText }
        });
      }
      var content = h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [inner]);
      rows.push(h('tr', [h('td', { attrs: { colspan: String(fields.length) } }, [content])]));
    } else {
      rows.push(h(false));
    }

    // Static bottom row slot
    if ($scoped['bottom-row']) {
      rows.push(h('tr', {}, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Assemble the rows into the tbody
    var tbody = h('tbody', {}, rows);

    // Return the assembled table
    return h('table', {
      class: t.tableClasses,
      attrs: { id: t.id || null, 'aria-busy': t.computedBusy ? 'true' : 'false' }
    }, [caption, colgroup, thead, tfoot, tbody]);
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],
      // Note: filteredItems only used to determine if # of items changed
      filteredItems: [],
      localBusy: this.busy
    };
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      default: ''
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          // Deprecate inverse
          Object(utils["n" /* warn */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      // Deprecated in v1.0.0.beta.10 in favor of `dark`
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    perPage: {
      type: Number,
      default: null
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    footClone: {
      type: Boolean,
      default: false
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!Object(utils["c" /* looseEqual */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        // Emit a filtered notification event, as number of filtered items has changed
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      // Emit update to sort-desc.sync
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    this.localBusy = this.busy;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this.id || id === _this) {
        _this._providerUpdate();
      }
    });
  },

  computed: {
    tableClasses: function tableClasses() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', responsive === true ? 'table-responsive' : Boolean(responsive) ? 'table-responsive-' + responsive : '', this.fixed ? 'table-fixed' : '', this.small ? 'table-sm' : ''];
    },
    headClasses: function headClasses() {
      return this.headVariant ? 'thead-' + this.headVariant : '';
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return variant ? 'thead-' + variant : '';
    },
    captionStyles: function captionStyles() {
      // Move caption to top
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        apiUrl: this.apiUrl,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc
      };
    },
    computedFields: function computedFields() {
      var _this2 = this;

      // We normalize fields into an array of objects
      // [ { key:..., label:..., ...}, {...}, ..., {..}]
      var fields = [];
      if (Object(array["d" /* isArray */])(this.fields)) {
        // Normalize array Form
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: lodash_startcase_default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : typeof_default()(f)) === 'object' && f.key && typeof f.key === 'string') {
            // Full object definition. We use assign so that we don't mutate the original
            fields.push(Object(object["a" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : typeof_default()(f)) === 'object' && Object(object["e" /* keys */])(f).length === 1) {
            // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
            var key = Object(object["e" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && typeof_default()(this.fields) === 'object' && Object(object["e" /* keys */])(this.fields).length > 0) {
        // Normalize object Form
        Object(object["e" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this2.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }
      // If no field provided, take a sample from first record (if exits)
      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        Object(object["e" /* keys */])(sample).forEach(function (k) {
          fields.push({ key: k, label: lodash_startcase_default()(k) });
        });
      }
      // Ensure we have a unique array of fields and that they have labels
      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = f.label || lodash_startcase_default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      // Grab some props/data to ensure reactivity
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }
      // Array copy for sorting, filtering, etc.
      items = items.slice();
      // Apply local filter
      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        // Make a local copy of filtered items to trigger filtered event
        this.filteredItems = items.slice();
      }
      // Apply local Sort
      if (sortBy && localSorting) {
        items = items.sort(function sortItemsFn(a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            // Call user provided sortCompare routine
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            // Fallback to defaultSortCompare if sortCompare not defined or returns null
            ret = defaultSortCompare(a, b, sortBy);
          }
          // Handle sorting direction
          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }
      // Apply local pagination
      if (Boolean(perPage) && localPaging) {
        // Grab the current page of data (which may be past filtered items)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      // Update the value model with the filtered/sorted/paginated data set
      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: object["e" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', field.tdClass ? field.tdClass : ''];
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : ''];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      var sortChanged = false;
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = field.key;
          this.localSortDesc = false;
        }
        sortChanged = true;
      } else if (this.localSortBy) {
        this.localSortBy = null;
        this.localSortDesc = false;
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        // Sorting parameters changed
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        // If table is busy (via provider) then don't propagate
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      // Expose refresh method
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      this.emitOnRoot('table::refreshed', this.id);
    },
    _providerUpdate: function _providerUpdate() {
      var _this3 = this;

      // Refresh the provider items
      if (this.computedBusy || !this.hasProvider) {
        // Don't refresh remote data if we are 'busy' or if no provider
        return;
      }
      // Set internal busy state
      this.localBusy = true;
      // Call provider function with context and optional callback
      var data = this.items(this.context, this._providerSetLocal);
      if (data) if (data.then && typeof data.then === 'function') {
        // Provider returned Promise
        data.then(function (items) {
          _this3._providerSetLocal(items);
        });
      } else {
        // Provider returned Array data
        this._providerSetLocal(data);
      }
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = item[key];
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/table/table.vue
function injectStyle (ssrContext) {
  __webpack_require__("JfbT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  table,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var table_table = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("FTkx");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1VmJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+hT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2SYH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5ZWw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "9JAL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AJtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/object.js
var object = __webpack_require__("/CDJ");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/link/link.js
var link_link = __webpack_require__("etPs");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/pagination-nav/pagination-nav.vue

//
//
//
//
//
//
//
//
//
//
//






// Props needed for router links
var routerProps = Object(link_link["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

// Props object
var pagination_nav_props = Object(object["a" /* assign */])(
// pagination-nav specific props
{
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
},
// Router specific props
routerProps);

// Our render function is brought in via the pagination mixin
/* harmony default export */ var pagination_nav = ({
  mixins: [mixins["k" /* paginationMixin */]],
  props: pagination_nav_props,
  computed: {
    // Used by render function to trigger wraping in '<nav>' element
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : typeof_default()(link)) === 'object') {
        props = Object(object["a" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/pagination-nav/pagination-nav.vue
function injectStyle (ssrContext) {
  __webpack_require__("qEor")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pagination_nav,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pagination_nav_pagination_nav = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DHS7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DNdj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FjQV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Valid supported input types
var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ var form_input = ({
    mixins: [mixins["i" /* idMixin */], mixins["d" /* formMixin */], mixins["g" /* formSizeMixin */], mixins["h" /* formStateMixin */]],
    render: function render(h) {
        var t = this;
        return h('input', {
            ref: 'input',
            class: t.inputClass,
            domProps: { value: t.localValue },
            attrs: {
                id: t.safeId(),
                name: t.name,
                type: t.localType,
                disabled: t.disabled,
                required: t.required,
                readonly: t.readonly || t.plaintext,
                placeholder: t.placeholder,
                autocomplete: t.autocomplete || null,
                'aria-required': t.required ? 'true' : null,
                'aria-invalid': t.computedAriaInvalid
            },
            on: {
                input: t.onInput,
                change: t.onChange
            }
        });
    },
    data: function data() {
        return {
            localValue: this.value
        };
    },

    props: {
        value: {
            default: null
        },
        type: {
            type: String,
            default: 'text',
            validator: function validator(type) {
                return Object(array["a" /* arrayIncludes */])(TYPES, type);
            }
        },
        ariaInvalid: {
            type: [Boolean, String],
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        plaintext: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        formatter: {
            type: Function
        },
        lazyFormatter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        localType: function localType() {
            // We only allow certain types
            return Object(array["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
        },
        inputClass: function inputClass() {
            return [this.plaintext ? 'form-control-plaintext' : 'form-control',
            // Fix missing width:100% in Bootstrap V4.beta.2
            this.plaintext ? 'w-100' : '', this.sizeFormClass, this.stateClass];
        },
        computedAriaInvalid: function computedAriaInvalid() {
            if (!Boolean(this.ariaInvalid) || this.ariaInvalid === 'false') {
                // this.ariaInvalid is null or false or 'false'
                return this.computedState === false ? 'true' : null;
            }
            if (this.ariaInvalid === true) {
                // User wants explicit aria-invalid=true
                return 'true';
            }
            // Most likely a string value (which could be 'true')
            return this.ariaInvalid;
        }
    },
    watch: {
        value: function value(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.localValue = newVal;
            }
        },
        localValue: function localValue(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        format: function format(value, e) {
            if (this.formatter) {
                var formattedValue = this.formatter(value, e);
                if (formattedValue !== value) {
                    return formattedValue;
                }
            }
            return value;
        },
        onInput: function onInput(evt) {
            var value = evt.target.value;
            if (this.lazyFormatter) {
                // Update the model with the current unformated value
                this.localValue = value;
            } else {
                this.localValue = this.format(value, evt);
            }
        },
        onChange: function onChange(evt) {
            this.localValue = this.format(evt.target.value, evt);
            this.$emit('change', this.localValue);
        },
        focus: function focus() {
            if (!this.disabled) {
                this.$el.focus();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-input/form-input.vue
function injectStyle (ssrContext) {
  __webpack_require__("O7LI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_input_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/button/button.js
var button_button = __webpack_require__("E8q/");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/button/button-close.js
var button_close = __webpack_require__("NCKu");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/bv-event.class.js
var bv_event_class = __webpack_require__("5mWU");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/modal/modal.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// Selectors for padding/margin adjustments
var Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};

// ObserveDom config
var OBSERVER_CONFIG = {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class']
};

/* harmony default export */ var modal = ({
    mixins: [mixins["i" /* idMixin */], mixins["j" /* listenOnRootMixin */]],
    components: { bBtn: button_button["a" /* default */], bBtnClose: button_close["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Modal Header
        var header = h(false);
        if (!t.hideHeader) {
            var modalHeader = $slots['modal-header'];
            if (!modalHeader) {
                var closeButton = h(false);
                if (!t.hideHeaderClose) {
                    closeButton = h('b-btn-close', {
                        props: {
                            disabled: t.is_transitioning,
                            ariaLabel: t.headerCloseLabel,
                            textVariant: t.headerTextVariant
                        },
                        on: { click: function click(evt) {
                                t.hide('header-close');
                            } }
                    }, [$slots['modal-header-close']]);
                }
                modalHeader = [h(t.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || t.title]), closeButton];
            }
            header = h('header', {
                ref: 'header',
                class: t.headerClasses,
                attrs: { id: t.safeId('__BV_modal_header_') }
            }, [modalHeader]);
        }

        // Modal Body
        var body = h('div', {
            ref: 'body',
            class: t.bodyClasses,
            attrs: { id: t.safeId('__BV_modal_body_') }
        }, [$slots.default]);

        // Modal Footer
        var footer = h(false);
        if (!t.hideFooter) {
            var modalFooter = $slots['modal-footer'];
            if (!modalFooter) {
                var okButton = h(false);
                if (!t.okOnly) {
                    okButton = h('b-btn', {
                        props: {
                            variant: t.cancelVariant,
                            size: t.buttonSize,
                            disabled: t.cancelDisabled || t.busy || t.is_transitioning
                        },
                        on: { click: function click(evt) {
                                t.hide('cancel');
                            } }

                    }, [$slots['modal-cancel'] || t.cancelTitle]);
                }
                var cancelButton = h('b-btn', {
                    props: {
                        variant: t.okVariant,
                        size: t.buttonSize,
                        disabled: t.okDisabled || t.busy || t.is_transitioning
                    },
                    on: { click: function click(evt) {
                            t.hide('ok');
                        } }
                }, [$slots['modal-ok'] || t.okTitle]);
                modalFooter = [cancelButton, okButton];
            }
            footer = h('footer', {
                ref: 'footer',
                class: t.footerClasses,
                attrs: { id: t.safeId('__BV_modal_footer_') }
            }, [modalFooter]);
        }

        // Assemble Modal Content
        var modalContent = h('div', {
            ref: 'content',
            class: ['modal-content'],
            attrs: {
                tabindex: '-1',
                role: 'document',
                'aria-labelledby': t.hideHeader ? null : t.safeId('__BV_modal_header_'),
                'aria-describedby': t.safeId('__BV_modal_body_')
            },
            on: {
                focusout: t.onFocusout,
                click: function click(evt) {
                    evt.stopPropagation();
                }
            }
        }, [header, body, footer]);

        // Modal Dialog wrapper
        var modalDialog = h('div', { class: t.dialogClasses }, [modalContent]);

        // Modal
        var modal = h('div', {
            ref: 'modal',
            class: t.modalClasses,
            directives: [{ name: 'show', rawName: 'v-show', value: t.is_visible, expression: 'is_visible' }],
            attrs: {
                id: t.safeId(),
                role: 'dialog',
                'aria-hidden': t.is_visible ? null : 'true'
            },
            on: {
                click: t.onClickOut,
                keydown: t.onEsc
            }
        }, [modalDialog]);
        // Wrap modal in transition
        modal = h('transition', {
            props: {
                enterClass: '',
                enterToClass: '',
                enterActiveClass: '',
                leaveClass: '',
                leaveActiveClass: '',
                leaveToClass: ''
            },
            on: {
                'before-enter': t.onBeforeEnter,
                'enter': t.onEnter,
                'after-enter': t.onAfterEnter,
                'before-leave': t.onBeforeLeave,
                'leave': t.onLeave,
                'after-leave': t.onAfterLeave
            }
        }, [modal]);

        // Modal Backdrop
        var backdrop = h(false);
        if (!t.hideBackdrop && (t.is_visible || t.is_transitioning)) {
            backdrop = h('div', { class: t.backdropClasses, attrs: { id: t.safeId('__BV_modal_backdrop_') } });
        }

        // Assemble modal and backdrop
        var outer = h(false);
        if (!t.is_hidden) {
            outer = h('div', { attrs: { id: t.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
        }

        // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
        return h('div', {}, [outer]);
    },
    data: function data() {
        return {
            is_hidden: this.lazy || false,
            is_visible: false,
            is_transitioning: false,
            is_show: false,
            is_block: false,
            scrollbarWidth: 0,
            isBodyOverflowing: false,
            return_focus: this.returnFocus || null
        };
    },

    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        titleTag: {
            type: String,
            default: 'h5'
        },
        size: {
            type: String,
            default: 'md'
        },
        centered: {
            type: Boolean,
            default: false
        },
        buttonSize: {
            type: String,
            default: ''
        },
        noFade: {
            type: Boolean,
            default: false
        },
        noCloseOnBackdrop: {
            type: Boolean,
            default: false
        },
        noCloseOnEsc: {
            type: Boolean,
            default: false
        },
        noEnforceFocus: {
            type: Boolean,
            default: false
        },
        headerBgVariant: {
            type: String,
            default: null
        },
        headerBorderVariant: {
            type: String,
            default: null
        },
        headerTextVariant: {
            type: String,
            default: null
        },
        bodyBgVariant: {
            type: String,
            default: null
        },
        bodyTextVariant: {
            type: String,
            default: null
        },
        footerBgVariant: {
            type: String,
            default: null
        },
        footerBorderVariant: {
            type: String,
            default: null
        },
        footerTextVariant: {
            type: String,
            default: null
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: false
        },
        hideHeaderClose: {
            type: Boolean,
            default: false
        },
        hideBackdrop: {
            type: Boolean,
            default: false
        },
        okOnly: {
            type: Boolean,
            default: false
        },
        okDisabled: {
            type: Boolean,
            default: false
        },
        cancelDisabled: {
            type: Boolean,
            default: false
        },
        visible: {
            type: Boolean,
            default: false
        },
        returnFocus: {
            default: null
        },
        headerCloseLabel: {
            type: String,
            default: 'Close'
        },
        cancelTitle: {
            type: String,
            default: 'Cancel'
        },
        okTitle: {
            type: String,
            default: 'OK'
        },
        cancelVariant: {
            type: String,
            default: 'secondary'
        },
        okVariant: {
            type: String,
            default: 'primary'
        },
        lazy: {
            type: Boolean,
            default: false
        },
        busy: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalClasses: function modalClasses() {
            return ['modal', {
                fade: !this.noFade,
                show: this.is_show,
                'd-block': this.is_block
            }];
        },
        dialogClasses: function dialogClasses() {
            var _ref;

            return ['modal-dialog', (_ref = {}, defineProperty_default()(_ref, 'modal-' + this.size, Boolean(this.size)), defineProperty_default()(_ref, 'modal-dialog-centered', this.centered), _ref)];
        },
        backdropClasses: function backdropClasses() {
            return ['modal-backdrop', {
                fade: !this.noFade,
                show: this.is_show || this.noFade
            }];
        },
        headerClasses: function headerClasses() {
            var _ref2;

            return ['modal-header', (_ref2 = {
                'rounded-top': Boolean(this.headerBgVariant)
            }, defineProperty_default()(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), defineProperty_default()(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), defineProperty_default()(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2)];
        },
        bodyClasses: function bodyClasses() {
            var _ref3;

            return ['modal-body', (_ref3 = {}, defineProperty_default()(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), defineProperty_default()(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3)];
        },
        footerClasses: function footerClasses() {
            var _ref4;

            return ['modal-footer', (_ref4 = {
                'rounded-bottom': Boolean(this.footerBgVariant)
            }, defineProperty_default()(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), defineProperty_default()(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), defineProperty_default()(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4)];
        }
    },
    watch: {
        visible: function visible(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            this[newVal ? 'show' : 'hide']();
        }
    },
    methods: {
        // Public Methods
        show: function show() {
            if (this.is_visible) {
                return;
            }
            var showEvt = new bv_event_class["a" /* default */]('show', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                relatedTarget: null
            });
            this.emitEvent(showEvt);
            if (showEvt.defaultPrevented || this.is_visible) {
                // Don't show if canceled
                return;
            }
            if (Object(dom["j" /* hasClass */])(document.body, 'modal-open')) {
                // If another modal is already open, wait for it to close
                this.$root.$once('bv::modal::hidden', this.doShow);
            } else {
                // Show the modal
                this.doShow();
            }
        },
        hide: function hide(trigger) {
            if (!this.is_visible) {
                return;
            }
            var hideEvt = new bv_event_class["a" /* default */]('hide', {
                cancelable: true,
                vueTarget: this,
                target: this.$refs.modal,
                // this could be the trigger element/component reference
                relatedTarget: null,
                isOK: trigger || null,
                trigger: trigger || null,
                cancel: function cancel() {
                    // Backwards compatibility
                    Object(utils["n" /* warn */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
                    this.preventDefault();
                }
            });
            if (trigger === 'ok') {
                this.$emit('ok', hideEvt);
            } else if (trigger === 'cancel') {
                this.$emit('cancel', hideEvt);
            }
            this.emitEvent(hideEvt);
            // Hide if not canceled
            if (hideEvt.defaultPrevented || !this.is_visible) {
                return;
            }
            // stop observing for content changes
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
            this.is_visible = false;
            this.$emit('change', false);
        },

        // Private method to finish showing modal
        doShow: function doShow() {
            var _this = this;

            // Plce modal in DOM if lazy
            this.is_hidden = false;
            this.$nextTick(function () {
                // We do this in nextTick to ensure the modal is in DOM first before we show it
                _this.is_visible = true;
                _this.$emit('change', true);
                // Observe changes in modal content and adjust if necessary
                _this._observer = Object(utils["f" /* observeDom */])(_this.$refs.content, _this.adjustDialog.bind(_this), OBSERVER_CONFIG);
            });
        },

        // Transition Handlers
        onBeforeEnter: function onBeforeEnter() {
            this.is_transitioning = true;
            this.checkScrollbar();
            this.setScrollbar();
            this.adjustDialog();
            Object(dom["a" /* addClass */])(document.body, 'modal-open');
            this.setResizeEvent(true);
        },
        onEnter: function onEnter() {
            this.is_block = true;
            this.$refs.modal.scrollTop = 0;
        },
        onAfterEnter: function onAfterEnter() {
            var _this2 = this;

            this.is_show = true;
            this.is_transitioning = false;
            this.$nextTick(function () {
                _this2.focusFirst();
                var shownEvt = new bv_event_class["a" /* default */]('shown', {
                    cancelable: false,
                    vueTarget: _this2,
                    target: _this2.$refs.modal,
                    relatedTarget: null
                });
                _this2.emitEvent(shownEvt);
            });
        },
        onBeforeLeave: function onBeforeLeave() {
            this.is_transitioning = true;
            this.setResizeEvent(false);
        },
        onLeave: function onLeave() {
            // Remove the 'show' class
            this.is_show = false;
        },
        onAfterLeave: function onAfterLeave() {
            var _this3 = this;

            this.is_block = false;
            this.resetAdjustments();
            this.resetScrollbar();
            this.is_transitioning = false;
            Object(dom["s" /* removeClass */])(document.body, 'modal-open');
            this.$nextTick(function () {
                _this3.is_hidden = _this3.lazy || false;
                _this3.returnFocusTo();
                var hiddenEvt = new bv_event_class["a" /* default */]('hidden', {
                    cancelable: false,
                    vueTarget: _this3,
                    target: _this3.lazy ? null : _this3.$refs.modal,
                    relatedTarget: null
                });
                _this3.emitEvent(hiddenEvt);
            });
        },

        // Event emitter
        emitEvent: function emitEvent(bvEvt) {
            var type = bvEvt.type;
            this.$emit(type, bvEvt);
            this.$root.$emit('bv::modal::' + type, bvEvt);
        },

        // UI Event Handlers
        onClickOut: function onClickOut(evt) {
            // If backdrop clicked, hide modal
            if (this.is_visible && !this.noCloseOnBackdrop) {
                this.hide('backdrop');
            }
        },
        onEsc: function onEsc(evt) {
            // If ESC pressed, hide modal
            if (evt.keyCode === utils["a" /* KeyCodes */].ESC && this.is_visible && !this.noCloseOnEsc) {
                this.hide('esc');
            }
        },
        onFocusout: function onFocusout(evt) {
            // If focus leaves modal, bring it back
            // 'focusout' Event Listener bound on content
            var content = this.$refs.content;
            if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
                content.focus();
            }
        },

        // Resize Listener
        setResizeEvent: function setResizeEvent(on) {
            var _this4 = this;

            ['resize', 'orientationchange'].forEach(function (evtName) {
                if (on) {
                    Object(dom["d" /* eventOn */])(window, evtName, _this4.adjustDialog);
                } else {
                    Object(dom["c" /* eventOff */])(window, evtName, _this4.adjustDialog);
                }
            });
        },

        // Root Listener handlers
        showHandler: function showHandler(id, triggerEl) {
            if (id === this.id) {
                this.return_focus = triggerEl || null;
                this.show();
            }
        },
        hideHandler: function hideHandler(id) {
            if (id === this.id) {
                this.hide();
            }
        },
        modalListener: function modalListener(bvEvt) {
            // If another modal opens, close this one
            if (bvEvt.vueTarget !== this) {
                this.hide();
            }
        },

        // Focus control handlers
        focusFirst: function focusFirst() {
            // Don't try and focus if we are SSR
            if (typeof document === 'undefined') {
                return;
            }
            var content = this.$refs.content;
            var modal = this.$refs.modal;
            var activeElement = document.activeElement;
            if (activeElement && content && content.contains(activeElement)) {
                // If activeElement is child of content, no need to change focus
            } else if (content) {
                if (modal) {
                    modal.scrollTop = 0;
                }
                // Focus the modal content wrapper
                content.focus();
            }
        },
        returnFocusTo: function returnFocusTo() {
            // Prefer returnFocus prop over event specified return_focus value
            var el = this.returnFocus || this.return_focus || null;
            if (typeof el === 'string') {
                // CSS Selector
                el = Object(dom["t" /* select */])(el);
            }
            if (el) {
                el = el.$el || el;
                if (Object(dom["m" /* isVisible */])(el)) {
                    el.focus();
                }
            }
        },

        // Utility methods
        getScrollbarWidth: function getScrollbarWidth() {
            var scrollDiv = document.createElement('div');
            scrollDiv.className = 'modal-scrollbar-measure';
            document.body.appendChild(scrollDiv);
            this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        },
        adjustDialog: function adjustDialog() {
            if (!this.is_visible) {
                return;
            }
            var modal = this.$refs.modal;
            var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
            if (!this.isBodyOverflowing && isModalOverflowing) {
                modal.style.paddingLeft = this.scrollbarWidth + 'px';
            }
            if (this.isBodyOverflowing && !isModalOverflowing) {
                modal.style.paddingRight = this.scrollbarWidth + 'px';
            }
        },
        resetAdjustments: function resetAdjustments() {
            var modal = this.$refs.modal;
            if (modal) {
                modal.style.paddingLeft = '';
                modal.style.paddingRight = '';
            }
        },
        checkScrollbar: function checkScrollbar() {
            var rect = Object(dom["f" /* getBCR */])(document.body);
            this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
        },
        setScrollbar: function setScrollbar() {
            if (this.isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var computedStyle = window.getComputedStyle;
                var body = document.body;
                var scrollbarWidth = this.scrollbarWidth;
                // Adjust fixed content padding
                Object(dom["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                    var actualPadding = el.style.paddingRight;
                    var calculatedPadding = computedStyle(el).paddingRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
                    el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
                });
                // Adjust sticky content margin
                Object(dom["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
                });
                // Adjust navbar-toggler margin
                Object(dom["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
                    var actualMargin = el.style.marginRight;
                    var calculatedMargin = computedStyle(el).marginRight || 0;
                    Object(dom["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
                    el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
                });
                // Adjust body padding
                var actualPadding = body.style.paddingRight;
                var calculatedPadding = computedStyle(body).paddingRight;
                Object(dom["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
                body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
            }
        },
        resetScrollbar: function resetScrollbar() {
            // Restore fixed content padding
            Object(dom["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
                if (Object(dom["i" /* hasAttr */])(el, 'data-padding-right')) {
                    el.style.paddingRight = Object(dom["e" /* getAttr */])(el, 'data-padding-right') || '';
                    Object(dom["r" /* removeAttr */])(el, 'data-padding-right');
                }
            });
            // Restore sticky content and navbar-toggler margin
            Object(dom["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
                if (Object(dom["i" /* hasAttr */])(el, 'data-margin-right')) {
                    el.style.marginRight = Object(dom["e" /* getAttr */])(el, 'data-margin-right') || '';
                    Object(dom["r" /* removeAttr */])(el, 'data-margin-right');
                }
            });
            // Restore body padding
            var body = document.body;
            if (Object(dom["i" /* hasAttr */])(body, 'data-padding-right')) {
                body.style.paddingRight = Object(dom["e" /* getAttr */])(body, 'data-padding-right') || '';
                Object(dom["r" /* removeAttr */])(body, 'data-padding-right');
            }
        }
    },
    created: function created() {
        // create non-reactive property
        this._observer = null;
    },
    mounted: function mounted() {
        // Measure scrollbar
        this.getScrollbarWidth();
        // Listen for events from others to either open or close ourselves
        this.listenOnRoot('bv::show::modal', this.showHandler);
        this.listenOnRoot('bv::hide::modal', this.hideHandler);
        // Listen for bv:modal::show events, and close ourselves if the opening modal not us
        this.listenOnRoot('bv::modal::show', this.modalListener);
        // Initially show modal?
        if (this.visible === true) {
            this.show();
        }
    },
    beforeDestroy: function beforeDestroy() {
        // Ensure everything is back to normal
        if (this._observer) {
            this._observer.disconnect();
            this._observer = null;
        }
        this.setResizeEvent(false);
        // Re-adjust body/navbar/fixed padding/margins (if needed)
        Object(dom["s" /* removeClass */])(document.body, 'modal-open');
        this.resetAdjustments();
        this.resetScrollbar();
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/modal/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("TseW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var modal_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/array.js
var array = __webpack_require__("GnGf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-file/form-file.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var form_file = ({
    mixins: [mixins["i" /* idMixin */], mixins["d" /* formMixin */], mixins["h" /* formStateMixin */], mixins["c" /* formCustomMixin */]],
    render: function render(h) {
        var t = this;

        // Form Input
        var input = h('input', {
            ref: 'input',
            class: t.inputClasses,
            attrs: {
                type: 'file',
                id: t.safeId(),
                name: t.name,
                disabled: t.disabled,
                required: t.required,
                capture: t.capture || null,
                'aria-required': t.required ? 'true' : null,
                accept: t.accept || null,
                multiple: t.multiple,
                webkitdirectory: t.directory,
                'aria-describedby': t.plain ? null : t.safeId('_BV_file_control_')
            },
            on: {
                change: t.onFileChange,
                focusin: t.focusHandler,
                focusout: t.focusHandler
            }
        });

        if (t.plain) {
            return input;
        }

        // 'Drop Here' target
        var droptarget = h(false);
        if (t.dragging) {
            droptarget = h('span', {
                class: ['drop-here'],
                attrs: { 'data-drop': t.dropLabel },
                on: {
                    dragover: t.dragover,
                    drop: t.drop,
                    dragleave: t.dragleave
                }
            });
        }

        // Overlay Labels
        var labels = h('span', {
            class: ['custom-file-control', t.dragging ? 'dragging' : null],
            attrs: {
                id: t.safeId('_BV_file_control_'),
                'data-choose': t.computedChooseLabel,
                'data-selected': t.selectedLabel
            }
        });

        // Return rendered custom file input
        return h('label', {
            class: ['custom-file', 'b-form-file', t.stateClass, 'w-100', 'd-block'],
            attrs: { id: t.safeId('_BV_file_outer_') },
            on: { dragover: t.dragover }
        }, [droptarget, input, labels]);
    },
    data: function data() {
        return {
            selectedFile: null,
            dragging: false,
            hasFocus: false
        };
    },

    props: {
        accept: {
            type: String,
            default: ''
        },
        capture: {
            // Instruct input to capture from camera
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: null
        },
        chooseLabel: {
            type: String,
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        directory: {
            type: Boolean,
            default: false
        },
        noTraverse: {
            type: Boolean,
            default: false
        },
        selectedFormat: {
            type: String,
            default: ':count Files'
        },
        noDrop: {
            type: Boolean,
            default: false
        },
        dropLabel: {
            type: String,
            default: 'Drop files here'
        }
    },
    computed: {
        inputClasses: function inputClasses() {
            return [{
                'form-control-file': this.plain,
                'custom-file-input': this.custom,
                'w-100': true, // BS4 beta missing this
                'focus': this.custom && this.hasFocus
            }, this.stateClass];
        },
        selectedLabel: function selectedLabel() {
            if (!this.selectedFile || this.selectedFile.length === 0) {
                return this.placeholder || 'No file chosen';
            }
            if (this.multiple) {
                if (this.selectedFile.length === 1) {
                    return this.selectedFile[0].name;
                }
                return this.selectedFormat.replace(':names', this.selectedFile.map(function (file) {
                    return file.name;
                }).join(',')).replace(':count', this.selectedFile.length);
            }
            return this.selectedFile.name;
        },
        computedChooseLabel: function computedChooseLabel() {
            return this.chooseLabel || (this.multiple ? 'Choose Files' : 'Choose File');
        }
    },
    watch: {
        selectedFile: function selectedFile(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (!newVal && this.multiple) {
                this.$emit('input', []);
            } else {
                this.$emit('input', newVal);
            }
        }
    },
    methods: {
        focusHandler: function focusHandler(evt) {
            // Boostrap v4.beta doesn't have focus styling for custom file input
            // Firefox has a borked '[type=file]:focus ~ sibling' selector issue,
            // So we add a 'focus' class to get around these "bugs"
            if (this.plain || evt.type === 'focusout') {
                this.hasFocus = false;
            } else {
                // Add focus styling for custom file input
                this.hasFocus = true;
            }
        },
        reset: function reset() {
            try {
                // Wrapped in try in case IE < 11 craps out
                this.$refs.input.value = '';
            } catch (e) {}
            // IE < 11 doesn't support setting input.value to '' or null
            // So we use this little extra hack to reset the value, just in case
            // This also appears to work on modern browsers as well.
            this.$refs.input.type = '';
            this.$refs.input.type = 'file';
            this.selectedFile = this.multiple ? [] : null;
        },
        onFileChange: function onFileChange(evt) {
            var _this = this;

            // Always emit original event
            this.$emit('change', evt);
            // Check if special `items` prop is available on event (drop mode)
            // Can be disabled by setting no-traverse
            var items = evt.dataTransfer && evt.dataTransfer.items;
            if (items && !this.noTraverse) {
                var queue = [];
                for (var i = 0; i < items.length; i++) {
                    var item = items[i].webkitGetAsEntry();
                    if (item) {
                        queue.push(this.traverseFileTree(item));
                    }
                }
                promise_default.a.all(queue).then(function (filesArr) {
                    _this.setFiles(Object(array["c" /* from */])(filesArr));
                });
                return;
            }
            // Normal handling
            this.setFiles(evt.target.files || evt.dataTransfer.files);
        },
        setFiles: function setFiles(files) {
            if (!files) {
                this.selectedFile = null;
                return;
            }
            if (!this.multiple) {
                this.selectedFile = files[0];
                return;
            }
            // Convert files to array
            var filesArray = [];
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.match(this.accept)) {
                    filesArray.push(files[i]);
                }
            }
            this.selectedFile = filesArray;
        },
        dragover: function dragover(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop || !this.custom) {
                return;
            }
            this.dragging = true;
            evt.dataTransfer.dropEffect = 'copy';
        },
        dragleave: function dragleave(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            this.dragging = false;
        },
        drop: function drop(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (this.noDrop) {
                return;
            }
            this.dragging = false;
            if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
                this.onFileChange(evt);
            }
        },
        traverseFileTree: function traverseFileTree(item, path) {
            var _this2 = this;

            // Based on http://stackoverflow.com/questions/3590058
            return new promise_default.a(function (resolve) {
                path = path || '';
                if (item.isFile) {
                    // Get file
                    item.file(function (file) {
                        file.$path = path; // Inject $path to file obj
                        resolve(file);
                    });
                } else if (item.isDirectory) {
                    // Get folder contents
                    item.createReader().readEntries(function (entries) {
                        var queue = [];
                        for (var i = 0; i < entries.length; i++) {
                            queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
                        }
                        promise_default.a.all(queue).then(function (filesArr) {
                            resolve(Object(array["c" /* from */])(filesArr));
                        });
                    });
                }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-file/form-file.vue
function injectStyle (ssrContext) {
  __webpack_require__("w1yP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_file,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_file_form_file = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JfbT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/Users/kavu/dev/qi_composites_client"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/Users/kavu/dev/qi_composites_client","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/es6-promise/auto.js
var auto = __webpack_require__("MU8w");
var auto_default = /*#__PURE__*/__webpack_require__.n(auto);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/raven-js/src/singleton.js
var singleton = __webpack_require__("/Hyb");
var singleton_default = /*#__PURE__*/__webpack_require__.n(singleton);

// EXTERNAL MODULE: ./node_modules/raven-js/plugins/vue.js
var vue = __webpack_require__("6fN7");
var vue_default = /*#__PURE__*/__webpack_require__.n(vue);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/index.js + 116 modules
var es = __webpack_require__("e6fC");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695f5b9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("DNdj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/jsonwebtoken/index.js
var jsonwebtoken = __webpack_require__("abWm");
var jsonwebtoken_default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/server.js




var instance = axios_default.a.create({
  baseURL: "https://api.qicomposites.com/v1"
});

instance.interceptors.request.use(function (config) {
  if (store.getters.currentToken) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.currentToken;
  }
  return config;
}, function (error) {
  // Do something with request error
  return promise_default.a.reject(error);
});

/* harmony default export */ var server = (instance);
// CONCATENATED MODULE: ./src/store.js





vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    currentToken: localStorage.getItem('qidtoken')
  },
  mutations: {
    login: function login(state, data) {
      state.currentToken = data;
    },
    logout: function logout(state) {
      state.currentToken = null;
    }
  },
  actions: {
    login: function login(_ref, credentials) {
      var commit = _ref.commit;

      return server.post('/login', { email: credentials.email, password: credentials.password }).then(function (res) {
        commit('login', res.data.token);
        localStorage.setItem('qidtoken', res.data.token);
        return res;
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      localStorage.removeItem('qidtoken');
      commit('logout');
    }
  },
  getters: {
    currentToken: function currentToken(state) {
      return state.currentToken;
    },
    currentUser: function currentUser(state) {
      var userData = jsonwebtoken_default.a.decode(state.currentToken);
      if (userData) {
        return {
          id: userData.sub,
          fullName: userData.full_name,
          email: userData.email,
          role: userData.role
        };
      }
      return null;
    },
    currentRole: function currentRole(state, getters) {
      var userData = getters.currentUser;
      if (!userData) {
        return null;
      }
      return userData.role;
    },
    isAdmin: function isAdmin(state, getters) {
      return getters.currentRole === 'admin';
    },
    isOperator: function isOperator(state, getters) {
      return getters.currentRole === 'operator';
    },
    isCustomer: function isCustomer(state, getters) {
      return getters.currentRole === 'customer';
    }
  }
}));
// CONCATENATED MODULE: ./src/utils/Policeman/permissions.js
var defaultPerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: false },
  operator: { index: false, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: false, show: false, new: false, edit: false, ban: false, delete: false }
};
var dashboardPerms = {
  admin: { index: true, show: false, new: false, edit: false, ban: false, delete: false },
  operator: { index: true, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: true, show: false, new: false, edit: false, ban: false, delete: false }
};
var userPerms = {
  admin: { index: true, show: false, new: true, edit: true, ban: false, delete: false },
  operator: { index: false, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: false, show: false, new: false, edit: false, ban: false, delete: false }
};
var projectPerms = {
  admin: { index: true, show: false, new: true, edit: true, ban: false, delete: true },
  operator: { index: true, show: false, new: false, edit: false, ban: false, delete: false },
  customer: { index: false, show: false, new: false, edit: false, ban: false, delete: false }
};
var structurePerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: true },
  operator: { index: true, show: true, new: false, edit: false, ban: false, delete: false },
  customer: { index: true, show: true, new: false, edit: false, ban: false, delete: false }
};
var checklistPerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: false },
  operator: { index: true, show: true, new: true, edit: true, ban: false, delete: false },
  customer: { index: true, show: true, new: false, edit: false, ban: false, delete: false }
};
var checklistItemPerms = {
  admin: { index: true, show: true, new: true, edit: true, ban: false, delete: true },
  operator: { index: true, show: true, new: true, edit: true, ban: false, delete: true },
  customer: { index: true, show: true, new: false, edit: false, ban: false, delete: false }
};

/* harmony default export */ var permissions = ({
  default: defaultPerms,
  dashboard: dashboardPerms,
  user: userPerms,
  project: projectPerms,
  structure: structurePerms,
  object: structurePerms,
  checklist: checklistPerms,
  inspection: checklistPerms,
  checklistItem: checklistItemPerms
});
// CONCATENATED MODULE: ./src/utils/Policeman/policeman.js




var ALL_ROLES = ['admin', 'operator', 'customer'];

var policeman_evalRoles = function evalRoles() {
  var roles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (roles.length <= 0) {
    return true;
  }
  return roles.includes(store.getters.currentRole);
};

var policeman_canUser = function canUser(role, action, entity) {
  return permissions[entity][role][action];
};

var policeman_verifyToken = function verifyToken() {
  // if token exists
  var currentToken = store.getters.currentToken;
  if (!currentToken) {
    return false;
  }
  // if token is valid
  var tokenData = jsonwebtoken_default.a.decode(currentToken);
  var tokenExp = new Date(tokenData.exp * 1000);
  var datenow = new Date();
  if (datenow > tokenExp) {
    return false;
  }
  return true;
};

/* harmony default export */ var policeman = ({
  authorize: function authorize() {
    var roles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (policeman_verifyToken()) {
      return policeman_evalRoles(roles);
    }
    return false;
  },
  permitActions: function permitActions() {
    var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

    var role = store.getters.currentRole;
    return permissions[entity][role];
  },
  getRoles: function getRoles(entity, action) {
    var users = [];
    ALL_ROLES.forEach(function (user) {
      if (policeman_canUser(user, action, entity)) {
        users.push(user);
      }
    });
    return users;
  },
  can: function can(action) {
    var entity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

    var role = store.getters.currentRole;
    if (policeman_verifyToken() && permissions[entity][role][action]) {
      return true;
    }
    return false;
  },
  isAdmin: function isAdmin() {
    if (store.getters.currentRole === 'admin') {
      return true;
    }
    return false;
  },
  isOperator: function isOperator() {
    if (store.getters.currentRole === 'operator') {
      return true;
    }
    return false;
  },
  isCustomer: function isCustomer() {
    if (store.getters.currentRole === 'customer') {
      return true;
    }
    return false;
  },
  isLogged: policeman_verifyToken
});
// CONCATENATED MODULE: ./src/_nav.js


var _nav_sidebarItems = function sidebarItems() {
  return {
    items: [{
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-pie-chart',
      roles: policeman.getRoles('dashboard', 'index')
    }, {
      name: 'Objects',
      url: '/structures',
      icon: 'icon-speedometer',
      roles: policeman.getRoles('structure', 'index')
    }, {
      name: 'Users',
      url: '/users',
      icon: 'icon-people',
      roles: policeman.getRoles('user', 'index')
    }, {
      name: 'Projects',
      url: '/projects',
      icon: 'icon-event',
      roles: policeman.getRoles('project', 'index')
    }, {
      name: 'Inspections',
      url: '/checklists',
      icon: 'icon-list',
      roles: policeman.getRoles('checklist', 'index')
    }]
  };
};


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Breadcrumb.vue
//
//
//
//
//
//
//

/* harmony default export */ var Breadcrumb = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7410c529","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
var Breadcrumb_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var Breadcrumb_staticRenderFns = []
var Breadcrumb_esExports = { render: Breadcrumb_render, staticRenderFns: Breadcrumb_staticRenderFns }
/* harmony default export */ var components_Breadcrumb = (Breadcrumb_esExports);
// CONCATENATED MODULE: ./src/components/Breadcrumb.vue
var Breadcrumb_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Breadcrumb___vue_template_functional__ = false
/* styles */
var Breadcrumb___vue_styles__ = null
/* scopeId */
var Breadcrumb___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Breadcrumb___vue_module_identifier__ = null
var Breadcrumb_Component = Breadcrumb_normalizeComponent(
  Breadcrumb,
  components_Breadcrumb,
  Breadcrumb___vue_template_functional__,
  Breadcrumb___vue_styles__,
  Breadcrumb___vue_scopeId__,
  Breadcrumb___vue_module_identifier__
)

/* harmony default export */ var src_components_Breadcrumb = (Breadcrumb_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Footer.vue
//
//
//

/* harmony default export */ var Footer = ({
  name: 'footer'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42da43cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer mt-4"})}
var Footer_staticRenderFns = []
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var components_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/components/Footer.vue
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = null
/* scopeId */
var Footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  components_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_components_Footer = (Footer_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header/HeaderDropdownAccnt.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HeaderDropdownAccnt = ({
  name: 'header-dropdown-accnt',
  data: function data() {
    return { itemsCount: 42 };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea49d52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownAccnt.vue
var HeaderDropdownAccnt_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Account")])]),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-bell-o"}),_vm._v(" Updates"),_c('b-badge',{attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" Messages"),_c('b-badge',{attrs:{"variant":"success"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-tasks"}),_vm._v(" Tasks"),_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-comments"}),_vm._v(" Comments"),_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Settings")])]),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Profile")]),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Settings")]),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-usd"}),_vm._v(" Payments"),_c('b-badge',{attrs:{"variant":"light"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-file"}),_vm._v(" Projects"),_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-divider'),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" Lock Account")]),_c('b-dropdown-item',[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Logout")])],2)}
var HeaderDropdownAccnt_staticRenderFns = []
var HeaderDropdownAccnt_esExports = { render: HeaderDropdownAccnt_render, staticRenderFns: HeaderDropdownAccnt_staticRenderFns }
/* harmony default export */ var Header_HeaderDropdownAccnt = (HeaderDropdownAccnt_esExports);
// CONCATENATED MODULE: ./src/components/Header/HeaderDropdownAccnt.vue
var HeaderDropdownAccnt_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var HeaderDropdownAccnt___vue_template_functional__ = false
/* styles */
var HeaderDropdownAccnt___vue_styles__ = null
/* scopeId */
var HeaderDropdownAccnt___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HeaderDropdownAccnt___vue_module_identifier__ = null
var HeaderDropdownAccnt_Component = HeaderDropdownAccnt_normalizeComponent(
  HeaderDropdownAccnt,
  Header_HeaderDropdownAccnt,
  HeaderDropdownAccnt___vue_template_functional__,
  HeaderDropdownAccnt___vue_styles__,
  HeaderDropdownAccnt___vue_scopeId__,
  HeaderDropdownAccnt___vue_module_identifier__
)

/* harmony default export */ var components_Header_HeaderDropdownAccnt = (HeaderDropdownAccnt_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header/HeaderDropdownTasks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HeaderDropdownTasks = ({
  name: 'header-dropdown-tasks',
  data: function data() {
    return { itemsCount: 15 };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340f4b8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownTasks.vue
var HeaderDropdownTasks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-list"}),_c('b-badge',{attrs:{"pill":"","variant":"warning"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-header',{staticClass:"dropdown-menu-lg text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("You have "+_vm._s(_vm.itemsCount)+" pending tasks")])]),_c('b-dropdown-item',[_c('div',{staticClass:"small mb-1"},[_vm._v("Upgrade NPM & Bower"),_c('span',{staticClass:"float-right"},[_c('strong',[_vm._v("0%")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"info","value":0}})],1),_c('b-dropdown-item',[_c('div',{staticClass:"small mb-1"},[_vm._v("ReactJS Version"),_c('span',{staticClass:"float-right"},[_c('strong',[_vm._v("25%")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"danger","value":25}})],1),_c('b-dropdown-item',[_c('div',{staticClass:"small mb-1"},[_vm._v("VueJS Version"),_c('span',{staticClass:"float-right"},[_c('strong',[_vm._v("50%")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"warning","value":50}})],1),_c('b-dropdown-item',[_c('div',{staticClass:"small mb-1"},[_vm._v("Add new layouts"),_c('span',{staticClass:"float-right"},[_c('strong',[_vm._v("75%")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"info","value":75}})],1),_c('b-dropdown-item',[_c('div',{staticClass:"small mb-1"},[_vm._v("Angular 2 Cli Version"),_c('span',{staticClass:"float-right"},[_c('strong',[_vm._v("100%")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"success","value":100}})],1),_c('b-dropdown-item',{staticClass:"text-center"},[_c('strong',[_vm._v("View all tasks")])])],2)}
var HeaderDropdownTasks_staticRenderFns = []
var HeaderDropdownTasks_esExports = { render: HeaderDropdownTasks_render, staticRenderFns: HeaderDropdownTasks_staticRenderFns }
/* harmony default export */ var Header_HeaderDropdownTasks = (HeaderDropdownTasks_esExports);
// CONCATENATED MODULE: ./src/components/Header/HeaderDropdownTasks.vue
var HeaderDropdownTasks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var HeaderDropdownTasks___vue_template_functional__ = false
/* styles */
var HeaderDropdownTasks___vue_styles__ = null
/* scopeId */
var HeaderDropdownTasks___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HeaderDropdownTasks___vue_module_identifier__ = null
var HeaderDropdownTasks_Component = HeaderDropdownTasks_normalizeComponent(
  HeaderDropdownTasks,
  Header_HeaderDropdownTasks,
  HeaderDropdownTasks___vue_template_functional__,
  HeaderDropdownTasks___vue_styles__,
  HeaderDropdownTasks___vue_scopeId__,
  HeaderDropdownTasks___vue_module_identifier__
)

/* harmony default export */ var components_Header_HeaderDropdownTasks = (HeaderDropdownTasks_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header/HeaderDropdownNotif.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HeaderDropdownNotif = ({
  name: 'header-dropdown-notif',
  data: function data() {
    return { itemsCount: 5 };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abf49afe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownNotif.vue
var HeaderDropdownNotif_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-bell"}),_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('b-dropdown-header',{staticClass:"dropdown-menu-lg text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("You have "+_vm._s(_vm.itemsCount)+" notifications")])]),_c('b-dropdown-item',[_c('i',{staticClass:"icon-user-follow text-success"}),_vm._v(" New user registered")]),_c('b-dropdown-item',[_c('i',{staticClass:"icon-user-unfollow text-danger"}),_vm._v(" User deleted")]),_c('b-dropdown-item',[_c('i',{staticClass:"icon-chart text-info"}),_vm._v(" Sales report is ready")]),_c('b-dropdown-item',[_c('i',{staticClass:"icon-basket-loaded text-primary"}),_vm._v(" New client")]),_c('b-dropdown-item',[_c('i',{staticClass:"icon-speedometer text-warning"}),_vm._v(" Server overloaded")]),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("Server")])]),_c('b-dropdown-item',[_c('div',{staticClass:"text-uppercase mb-1"},[_c('small',[_c('b',[_vm._v("CPU Usage")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"info","value":25}},[_c('small',{staticClass:"text-muted"},[_vm._v("348 Processes. 1/4 Cores.")])])],1),_c('b-dropdown-item',[_c('div',{staticClass:"text-uppercase mb-1"},[_c('small',[_c('b',[_vm._v("Memory Usage")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"warning","value":70}},[_c('small',{staticClass:"text-muted"},[_vm._v("11444GB/16384MB")])])],1),_c('b-dropdown-item',[_c('div',{staticClass:"text-uppercase mb-1"},[_c('small',[_c('b',[_vm._v("SSD 1 Usage")])])]),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"danger","value":90}},[_c('small',{staticClass:"text-muted"},[_vm._v("243GB/256GB")])])],1)],2)}
var HeaderDropdownNotif_staticRenderFns = []
var HeaderDropdownNotif_esExports = { render: HeaderDropdownNotif_render, staticRenderFns: HeaderDropdownNotif_staticRenderFns }
/* harmony default export */ var Header_HeaderDropdownNotif = (HeaderDropdownNotif_esExports);
// CONCATENATED MODULE: ./src/components/Header/HeaderDropdownNotif.vue
var HeaderDropdownNotif_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var HeaderDropdownNotif___vue_template_functional__ = false
/* styles */
var HeaderDropdownNotif___vue_styles__ = null
/* scopeId */
var HeaderDropdownNotif___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HeaderDropdownNotif___vue_module_identifier__ = null
var HeaderDropdownNotif_Component = HeaderDropdownNotif_normalizeComponent(
  HeaderDropdownNotif,
  Header_HeaderDropdownNotif,
  HeaderDropdownNotif___vue_template_functional__,
  HeaderDropdownNotif___vue_styles__,
  HeaderDropdownNotif___vue_scopeId__,
  HeaderDropdownNotif___vue_module_identifier__
)

/* harmony default export */ var components_Header_HeaderDropdownNotif = (HeaderDropdownNotif_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header/HeaderDropdownMssgs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HeaderDropdownMssgs = ({
  name: 'header-dropdown-mssgs',
  data: function data() {
    return { itemsCount: 7 };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f55f7ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdownMssgs.vue
var HeaderDropdownMssgs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"icon-envelope-letter"}),_c('b-badge',{attrs:{"pill":"","variant":"info"}},[_vm._v(_vm._s(_vm.itemsCount))])],1),_c('div',{staticClass:"dropdown-menu-lg"},[_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_vm._v("You have "+_vm._s(_vm.itemsCount)+" messages")])]),_c('b-dropdown-item',[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("John Doe")]),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("Just now")])]),_c('div',{staticClass:"text-truncate font-weight-bold"},[_c('span',{staticClass:"fa fa-exclamation text-danger"}),_vm._v(" Important message")]),_c('div',{staticClass:"small text-muted text-truncate"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]),_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}}),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"warning"}})],1)]),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Jane Doe")]),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("5 minutes ago")])]),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_c('div',{staticClass:"small text-muted text-truncate"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]),_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}}),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"danger"}})],1)]),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Janet Doe")]),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_c('div',{staticClass:"small text-muted text-truncate"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]),_c('b-dropdown-item',{attrs:{"href":"#"}},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}}),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"info"}})],1)]),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Joe Doe")]),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("4:03 AM")])]),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_c('div',{staticClass:"small text-muted text-truncate"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]),_c('b-dropdown-item',{staticClass:"text-center",attrs:{"href":"#"}},[_c('strong',[_vm._v("View all messages")])])],1)],2)}
var HeaderDropdownMssgs_staticRenderFns = []
var HeaderDropdownMssgs_esExports = { render: HeaderDropdownMssgs_render, staticRenderFns: HeaderDropdownMssgs_staticRenderFns }
/* harmony default export */ var Header_HeaderDropdownMssgs = (HeaderDropdownMssgs_esExports);
// CONCATENATED MODULE: ./src/components/Header/HeaderDropdownMssgs.vue
var HeaderDropdownMssgs_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var HeaderDropdownMssgs___vue_template_functional__ = false
/* styles */
var HeaderDropdownMssgs___vue_styles__ = null
/* scopeId */
var HeaderDropdownMssgs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HeaderDropdownMssgs___vue_module_identifier__ = null
var HeaderDropdownMssgs_Component = HeaderDropdownMssgs_normalizeComponent(
  HeaderDropdownMssgs,
  Header_HeaderDropdownMssgs,
  HeaderDropdownMssgs___vue_template_functional__,
  HeaderDropdownMssgs___vue_styles__,
  HeaderDropdownMssgs___vue_scopeId__,
  HeaderDropdownMssgs___vue_module_identifier__
)

/* harmony default export */ var components_Header_HeaderDropdownMssgs = (HeaderDropdownMssgs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header/Header.vue

//
//
//
//
//
//
//
//








/* harmony default export */ var Header = ({
  name: 'header',
  components: {
    HeaderDropdownAccnt: components_Header_HeaderDropdownAccnt,
    HeaderDropdownTasks: components_Header_HeaderDropdownTasks,
    HeaderDropdownNotif: components_Header_HeaderDropdownNotif,
    HeaderDropdownMssgs: components_Header_HeaderDropdownMssgs
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])({
    currentUser: 'currentUser'
  })),
  methods: {
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    currentUserPresenter: function currentUserPresenter() {
      if (this.currentUser) {
        return '<h6 class="my-0">' + this.currentUser.fullName + '</h6><small>' + this.currentUser.role + '</small>';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2880f76f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}}),_c('b-navbar-nav',{staticClass:"d-none d-sm-block"},[_c('b-nav-item',{staticClass:"text-white text-right px-3",domProps:{"innerHTML":_vm._s(this.currentUserPresenter())}})],1)],1)}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var Header_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/Header/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("rdFu")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  Header_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var components_Header_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./src/utils/notificationsMsg.js
/* harmony default export */ var notificationsMsg = ({
  byStatus: function byStatus(value) {
    var subject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Resource';
    var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'created';

    switch (value) {
      case 200:
        switch (subject) {
          default:
            return {
              title: 'Success',
              message: subject + ' has been ' + modifier,
              type: 'success'
            };
        }
      case 201:
        switch (subject) {
          case 'Login':
            return {
              title: 'Authorization',
              message: 'Login successful',
              type: 'success'
            };
          case 'Logout':
            return {
              title: 'Authorization',
              message: 'Logout successful',
              type: 'success'
            };
          case 'Quick report':
            return {
              title: 'In progress...',
              message: 'We are generating the report, you will receive an email with instructions to download it',
              type: 'success',
              timeout: 5000
            };

          default:
            return {
              title: 'Success',
              message: subject + ' has been ' + modifier,
              type: 'success'
            };
        }
      case 400:
        switch (subject) {
          case 'Login':
            return {
              title: 'Authorization',
              message: 'Login Failed',
              type: 'error'
            };
          case 'Logout':
            return {
              title: 'Authorization',
              message: 'Logout Failed',
              type: 'error'
            };
          default:
            return {
              title: 'Bad request',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            };
        }
      case 401:
        switch (subject) {
          case 'Login':
            return {
              title: 'Authorization',
              message: 'Login failed',
              type: 'error'
            };
          case 'Logout':
            return {
              title: 'Authorization',
              message: 'Logout failed',
              type: 'error'
            };
          default:
            return {
              title: 'Unauthorized',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            };
        }
      case 403:
        switch (subject) {
          default:
            return {
              title: 'Forbidden',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            };
        }
      case 404:
        switch (subject) {
          default:
            return {
              title: 'Not found',
              message: 'Resource not found',
              type: 'error'
            };
        }
      case 422:
        switch (subject) {
          default:
            return {
              title: 'Unprocessable entity',
              message: subject + " hasn't been " + modifier,
              type: 'error'
            };
        }
      case 500:
        switch (subject) {
          default:
            return {
              title: 'Server Error',
              message: '',
              type: 'error'
            };
        }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Logout.vue
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Logout = ({
  name: 'Logout',
  methods: {
    logout: function logout() {
      var _this = this;

      if (confirm('Do you want to log out?')) {
        this.$store.dispatch('logout').then(function (res) {
          _this.showNotification(201);
          _this.$router.push({ name: 'Login' });
        }).catch(function (error) {
          console.log(error);
          _this.showNotification(400);
        });
      }
    },
    showNotification: function showNotification(status) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Logout'));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a53cbd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logout.vue
var Logout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("logoutAction",[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",on:{"click":_vm.logout}},[_c('i',{staticClass:"icon-logout"}),_vm._v(" Logout")])])])])],2)}
var Logout_staticRenderFns = []
var Logout_esExports = { render: Logout_render, staticRenderFns: Logout_staticRenderFns }
/* harmony default export */ var components_Logout = (Logout_esExports);
// CONCATENATED MODULE: ./src/components/Logout.vue
var Logout_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Logout___vue_template_functional__ = false
/* styles */
var Logout___vue_styles__ = null
/* scopeId */
var Logout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Logout___vue_module_identifier__ = null
var Logout_Component = Logout_normalizeComponent(
  Logout,
  components_Logout,
  Logout___vue_template_functional__,
  Logout___vue_styles__,
  Logout___vue_scopeId__,
  Logout___vue_module_identifier__
)

/* harmony default export */ var src_components_Logout = (Logout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarFooter.vue
//
//
//
//
//



/* harmony default export */ var SidebarFooter = ({
  components: { cLogoutAction: src_components_Logout },
  name: 'sidebar-footer'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210c8488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarFooter.vue
var SidebarFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-logout-action')],1)}
var SidebarFooter_staticRenderFns = []
var SidebarFooter_esExports = { render: SidebarFooter_render, staticRenderFns: SidebarFooter_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarFooter = (SidebarFooter_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarFooter.vue
var SidebarFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarFooter___vue_template_functional__ = false
/* styles */
var SidebarFooter___vue_styles__ = null
/* scopeId */
var SidebarFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarFooter___vue_module_identifier__ = null
var SidebarFooter_Component = SidebarFooter_normalizeComponent(
  SidebarFooter,
  Sidebar_SidebarFooter,
  SidebarFooter___vue_template_functional__,
  SidebarFooter___vue_styles__,
  SidebarFooter___vue_scopeId__,
  SidebarFooter___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarFooter = (SidebarFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarHeader.vue
//
//
//


/* harmony default export */ var SidebarHeader = ({
  name: 'sidebar-header'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2194ccbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarHeader.vue
var SidebarHeader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var SidebarHeader_staticRenderFns = []
var SidebarHeader_esExports = { render: SidebarHeader_render, staticRenderFns: SidebarHeader_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarHeader = (SidebarHeader_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarHeader.vue
var SidebarHeader_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarHeader___vue_template_functional__ = false
/* styles */
var SidebarHeader___vue_styles__ = null
/* scopeId */
var SidebarHeader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarHeader___vue_module_identifier__ = null
var SidebarHeader_Component = SidebarHeader_normalizeComponent(
  SidebarHeader,
  Sidebar_SidebarHeader,
  SidebarHeader___vue_template_functional__,
  SidebarHeader___vue_styles__,
  SidebarHeader___vue_scopeId__,
  SidebarHeader___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarHeader = (SidebarHeader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarMinimizer.vue
//
//
//


/* harmony default export */ var SidebarMinimizer = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01143388","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarMinimizer.vue
var SidebarMinimizer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var SidebarMinimizer_staticRenderFns = []
var SidebarMinimizer_esExports = { render: SidebarMinimizer_render, staticRenderFns: SidebarMinimizer_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarMinimizer = (SidebarMinimizer_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarMinimizer.vue
var SidebarMinimizer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarMinimizer___vue_template_functional__ = false
/* styles */
var SidebarMinimizer___vue_styles__ = null
/* scopeId */
var SidebarMinimizer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarMinimizer___vue_module_identifier__ = null
var SidebarMinimizer_Component = SidebarMinimizer_normalizeComponent(
  SidebarMinimizer,
  Sidebar_SidebarMinimizer,
  SidebarMinimizer___vue_template_functional__,
  SidebarMinimizer___vue_styles__,
  SidebarMinimizer___vue_scopeId__,
  SidebarMinimizer___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarMinimizer = (SidebarMinimizer_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarNavDivider.vue

//
//
//
//

/* harmony default export */ var SidebarNavDivider = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(toConsumableArray_default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-786342a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavDivider.vue
var SidebarNavDivider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var SidebarNavDivider_staticRenderFns = []
var SidebarNavDivider_esExports = { render: SidebarNavDivider_render, staticRenderFns: SidebarNavDivider_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarNavDivider = (SidebarNavDivider_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarNavDivider.vue
var SidebarNavDivider_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarNavDivider___vue_template_functional__ = false
/* styles */
var SidebarNavDivider___vue_styles__ = null
/* scopeId */
var SidebarNavDivider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarNavDivider___vue_module_identifier__ = null
var SidebarNavDivider_Component = SidebarNavDivider_normalizeComponent(
  SidebarNavDivider,
  Sidebar_SidebarNavDivider,
  SidebarNavDivider___vue_template_functional__,
  SidebarNavDivider___vue_styles__,
  SidebarNavDivider___vue_scopeId__,
  SidebarNavDivider___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarNavDivider = (SidebarNavDivider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarNavDropdown.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SidebarNavDropdown = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4a92b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavDropdown.vue
var SidebarNavDropdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var SidebarNavDropdown_staticRenderFns = []
var SidebarNavDropdown_esExports = { render: SidebarNavDropdown_render, staticRenderFns: SidebarNavDropdown_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarNavDropdown = (SidebarNavDropdown_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarNavDropdown.vue
var SidebarNavDropdown_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarNavDropdown___vue_template_functional__ = false
/* styles */
var SidebarNavDropdown___vue_styles__ = null
/* scopeId */
var SidebarNavDropdown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarNavDropdown___vue_module_identifier__ = null
var SidebarNavDropdown_Component = SidebarNavDropdown_normalizeComponent(
  SidebarNavDropdown,
  Sidebar_SidebarNavDropdown,
  SidebarNavDropdown___vue_template_functional__,
  SidebarNavDropdown___vue_styles__,
  SidebarNavDropdown___vue_scopeId__,
  SidebarNavDropdown___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarNavDropdown = (SidebarNavDropdown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarNavLink.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SidebarNavLink = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(toConsumableArray_default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc6d02d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavLink.vue
var SidebarNavLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var SidebarNavLink_staticRenderFns = []
var SidebarNavLink_esExports = { render: SidebarNavLink_render, staticRenderFns: SidebarNavLink_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarNavLink = (SidebarNavLink_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarNavLink.vue
var SidebarNavLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarNavLink___vue_template_functional__ = false
/* styles */
var SidebarNavLink___vue_styles__ = null
/* scopeId */
var SidebarNavLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarNavLink___vue_module_identifier__ = null
var SidebarNavLink_Component = SidebarNavLink_normalizeComponent(
  SidebarNavLink,
  Sidebar_SidebarNavLink,
  SidebarNavLink___vue_template_functional__,
  SidebarNavLink___vue_styles__,
  SidebarNavLink___vue_scopeId__,
  SidebarNavLink___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarNavLink = (SidebarNavLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarNavTitle.vue

//
//
//
//
//
//
//
//
//

/* harmony default export */ var SidebarNavTitle = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(toConsumableArray_default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1069fab2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavTitle.vue
var SidebarNavTitle_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v(_vm._s(_vm.name))])]:[_vm._v(_vm._s(_vm.name))]],2)}
var SidebarNavTitle_staticRenderFns = []
var SidebarNavTitle_esExports = { render: SidebarNavTitle_render, staticRenderFns: SidebarNavTitle_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarNavTitle = (SidebarNavTitle_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarNavTitle.vue
var SidebarNavTitle_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarNavTitle___vue_template_functional__ = false
/* styles */
var SidebarNavTitle___vue_styles__ = null
/* scopeId */
var SidebarNavTitle___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarNavTitle___vue_module_identifier__ = null
var SidebarNavTitle_Component = SidebarNavTitle_normalizeComponent(
  SidebarNavTitle,
  Sidebar_SidebarNavTitle,
  SidebarNavTitle___vue_template_functional__,
  SidebarNavTitle___vue_styles__,
  SidebarNavTitle___vue_scopeId__,
  SidebarNavTitle___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarNavTitle = (SidebarNavTitle_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarNavItem.vue

//
//
//
//
//

/* harmony default export */ var SidebarNavItem = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(toConsumableArray_default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32570814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavItem.vue
var SidebarNavItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var SidebarNavItem_staticRenderFns = []
var SidebarNavItem_esExports = { render: SidebarNavItem_render, staticRenderFns: SidebarNavItem_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarNavItem = (SidebarNavItem_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarNavItem.vue
var SidebarNavItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarNavItem___vue_template_functional__ = false
/* styles */
var SidebarNavItem___vue_styles__ = null
/* scopeId */
var SidebarNavItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarNavItem___vue_module_identifier__ = null
var SidebarNavItem_Component = SidebarNavItem_normalizeComponent(
  SidebarNavItem,
  Sidebar_SidebarNavItem,
  SidebarNavItem___vue_template_functional__,
  SidebarNavItem___vue_styles__,
  SidebarNavItem___vue_scopeId__,
  SidebarNavItem___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarNavItem = (SidebarNavItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/SidebarNavLabel.vue

//
//
//
//
//
//
//



/* harmony default export */ var SidebarNavLabel = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: components_Sidebar_SidebarNavItem,
    SidebarNavLink: components_Sidebar_SidebarNavLink
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(toConsumableArray_default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb17099","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarNavLabel.vue
var SidebarNavLabel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var SidebarNavLabel_staticRenderFns = []
var SidebarNavLabel_esExports = { render: SidebarNavLabel_render, staticRenderFns: SidebarNavLabel_staticRenderFns }
/* harmony default export */ var Sidebar_SidebarNavLabel = (SidebarNavLabel_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/SidebarNavLabel.vue
var SidebarNavLabel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SidebarNavLabel___vue_template_functional__ = false
/* styles */
var SidebarNavLabel___vue_styles__ = null
/* scopeId */
var SidebarNavLabel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SidebarNavLabel___vue_module_identifier__ = null
var SidebarNavLabel_Component = SidebarNavLabel_normalizeComponent(
  SidebarNavLabel,
  Sidebar_SidebarNavLabel,
  SidebarNavLabel___vue_template_functional__,
  SidebarNavLabel___vue_styles__,
  SidebarNavLabel___vue_scopeId__,
  SidebarNavLabel___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_SidebarNavLabel = (SidebarNavLabel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Sidebar/Sidebar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var Sidebar = ({
  name: 'sidebar',
  data: function data() {
    return {
      navList: []
    };
  },

  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: components_Sidebar_SidebarFooter,
    SidebarHeader: components_Sidebar_SidebarHeader,
    SidebarMinimizer: components_Sidebar_SidebarMinimizer,
    SidebarNavDivider: components_Sidebar_SidebarNavDivider,
    SidebarNavDropdown: components_Sidebar_SidebarNavDropdown,
    SidebarNavLink: components_Sidebar_SidebarNavLink,
    SidebarNavTitle: components_Sidebar_SidebarNavTitle,
    SidebarNavItem: components_Sidebar_SidebarNavItem,
    SidebarNavLabel: components_Sidebar_SidebarNavLabel
  },
  mounted: function mounted() {
    var newItems = this.$props.navItems.map(function (item) {
      item.auth = policeman.authorize(item.roles);
      delete item.roles;
      return item;
    });
    this.$set(this.$data, 'navList', newItems);
  },

  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-138023b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/Sidebar.vue
var Sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_vm._l((_vm.navList),function(item,index){return [(item.auth)?[(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]:_vm._e()]})],2),_vm._t("default")],2),_c('SidebarFooter'),_c('SidebarMinimizer')],1)}
var Sidebar_staticRenderFns = []
var Sidebar_esExports = { render: Sidebar_render, staticRenderFns: Sidebar_staticRenderFns }
/* harmony default export */ var Sidebar_Sidebar = (Sidebar_esExports);
// CONCATENATED MODULE: ./src/components/Sidebar/Sidebar.vue
function Sidebar_injectStyle (ssrContext) {
  __webpack_require__("cYau")
}
var Sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Sidebar___vue_template_functional__ = false
/* styles */
var Sidebar___vue_styles__ = Sidebar_injectStyle
/* scopeId */
var Sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sidebar___vue_module_identifier__ = null
var Sidebar_Component = Sidebar_normalizeComponent(
  Sidebar,
  Sidebar_Sidebar,
  Sidebar___vue_template_functional__,
  Sidebar___vue_styles__,
  Sidebar___vue_scopeId__,
  Sidebar___vue_module_identifier__
)

/* harmony default export */ var components_Sidebar_Sidebar = (Sidebar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/Switch.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Switch = ({
  name: 'Switch',
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2774ba2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Switch.vue
var Switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_c('span',{staticClass:"switch-handle"})],2)}
var Switch_staticRenderFns = []
var Switch_esExports = { render: Switch_render, staticRenderFns: Switch_staticRenderFns }
/* harmony default export */ var Shared_Switch = (Switch_esExports);
// CONCATENATED MODULE: ./src/components/Shared/Switch.vue
var Switch_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Switch___vue_template_functional__ = false
/* styles */
var Switch___vue_styles__ = null
/* scopeId */
var Switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Switch___vue_module_identifier__ = null
var Switch_Component = Switch_normalizeComponent(
  Switch,
  Shared_Switch,
  Switch___vue_template_functional__,
  Switch___vue_styles__,
  Switch___vue_scopeId__,
  Switch___vue_module_identifier__
)

/* harmony default export */ var components_Shared_Switch = (Switch_Component.exports);

// CONCATENATED MODULE: ./src/components/index.js







// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/containers/Full.vue
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Full = ({
  name: 'full',
  components: {
    AppHeader: components_Header_Header,
    Sidebar: components_Sidebar_Sidebar,
    AppFooter: src_components_Footer,
    Breadcrumb: src_components_Breadcrumb
  },
  data: function data() {
    return {
      nav: _nav_sidebarItems().items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6949d3f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
var Full_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)],1),_c('AppFooter')],1)}
var Full_staticRenderFns = []
var Full_esExports = { render: Full_render, staticRenderFns: Full_staticRenderFns }
/* harmony default export */ var containers_Full = (Full_esExports);
// CONCATENATED MODULE: ./src/containers/Full.vue
var Full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Full___vue_template_functional__ = false
/* styles */
var Full___vue_styles__ = null
/* scopeId */
var Full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Full___vue_module_identifier__ = null
var Full_Component = Full_normalizeComponent(
  Full,
  containers_Full,
  Full___vue_template_functional__,
  Full___vue_styles__,
  Full___vue_scopeId__,
  Full___vue_module_identifier__
)

/* harmony default export */ var src_containers_Full = (Full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Login = ({
  name: 'Login',
  data: function data() {
    return {
      user: {
        email: '',
        password: ''
      }
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (policeman.isLogged()) {
      return next({ name: 'Home' });
    }
    return next();
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$store.dispatch('login', _this.user).then(function (res) {
            _this.showNotification(res.status);
            _this.$router.push({ name: 'Home' });
          }).catch(function (error) {
            _this.showNotification(error.response.status);
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    showNotification: function showNotification(status) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Login'));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-912ea142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card-group mb-4"},[_c('div',{staticClass:"card p-4"},[_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Login")]),_c('p',{staticClass:"text-muted"},[_vm._v("Sign In to your account")]),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('div',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group"},[_vm._m(0,false,false),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.user.email),expression:"user.email"}],staticClass:"form-control",attrs:{"name":"email","type":"email","placeholder":"Email","data-vv-validate-on":"blur"},domProps:{"value":(_vm.user.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "email", $event.target.value)}}})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('email')))])]),_c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"input-group"},[_vm._m(1,false,false),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",attrs:{"name":"password","type":"password","placeholder":"Password"},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password')))])]),_vm._m(2,false,false)])])]),_vm._m(3,false,false)])])])])])}
var Login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Login")])]),_c('div',{staticClass:"col-6 text-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card text-white bg-primary py-5 d-md-down-none",staticStyle:{"width":"44%"}},[_c('div',{staticClass:"card-body text-center"},[_c('div',[_c('div',{staticClass:"login-brand mb-4"}),_c('p',{staticClass:"text-left"},[_vm._v("You must be logged in to access your data.\nThe registration is not free, if you are an our customer and want to access the service,\n"),_c('span',[_c('strong',[_c('a',{staticClass:"text-white",attrs:{"href":"mailto:info@qicomposites.com"}},[_vm._v("contact us")])])])])])])])}]
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("1VmJ")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./src/utils/apiRoutes.js
var pluralize = __webpack_require__("DbJJ");

var listOrCreate = function listOrCreate(entity) {
  if (!entity) {
    return '';
  }
  return '/' + pluralize(entity);
};

var showOrEdit = function showOrEdit(entity, id) {
  if (!entity) {
    return '';
  }
  return '/' + pluralize(entity) + '/' + id;
};

/* harmony default export */ var apiRoutes = ({
  index: function index() {
    var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return listOrCreate(entity);
  },

  show: function show() {
    var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var id = arguments[1];

    return showOrEdit(entity, id);
  },

  create: function create() {
    var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    return listOrCreate(entity);
  },

  edit: function edit() {
    var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var id = arguments[1];

    return showOrEdit(entity, id);
  },

  delete: function _delete() {
    var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var id = arguments[1];

    return showOrEdit(entity, id);
  }
});
// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__("H9QG");
var luxon_default = /*#__PURE__*/__webpack_require__.n(luxon);

// CONCATENATED MODULE: ./src/utils/resourceNormalizer.js




var options = {
  user_role: [{ value: 'customer', text: 'Customer' }, { value: 'operator', text: 'Operator' }, { value: 'admin', text: 'Administrator' }],

  project_type: [{ value: 'spot', text: 'Spot' }, { value: 'manufacturing', text: 'Manufacturing' }, { value: 'yacht_racing', text: 'Yacht Racing' }, { value: 'automotive', text: 'Automotive' }, { value: 'monitoring', text: 'Monitoring' }],

  structure_type: [{ value: 'car', text: 'Car' }, { value: 'boat', text: 'Boat' }, { value: 'wind_turbine', text: 'Wind turbine' }, { value: 'rig', text: 'Rig' }, { value: 'boom', text: 'Boom' }, { value: 'shrouds', text: 'Shrouds' }, { value: 'other', text: 'Other' }]
};

var resourceNormalizer_formatProjectType = function formatProjectType(key) {
  var typeArray = options.project_type.map(function (data) {
    if (key === data.value) {
      return data.text;
    }
  });
  return lodash_default.a.remove(typeArray, undefined)[0];
};

var resourceNormalizer_formatStructureType = function formatStructureType(key) {
  var typeArray = options.structure_type.map(function (data) {
    if (key === data.value) {
      return data.text;
    }
  });
  return lodash_default.a.remove(typeArray, undefined)[0];
};

var resourceNormalizer_formatUserRole = function formatUserRole(key) {
  var typeArray = options.user_role.map(function (data) {
    if (key === data.value) {
      return data.text;
    }
  });
  return lodash_default.a.remove(typeArray, undefined)[0];
};

var getValue = function getValue(entity, field, value) {
  var result = value;
  options[entity + '_' + field].forEach(function (option) {
    if (option.value === value) {
      result = option.text;
    }
  });
  return result;
};

var userNormalizer = function userNormalizer(entity, resource) {
  return {
    id: resource.id,
    first_name: resource.first_name,
    last_name: resource.last_name,
    company: resource.company,
    role: getValue(entity, 'role', resource.role),
    email: resource.email
  };
};

var resourceNormalizer_projectNormalizer = function projectNormalizer(entity, resource) {
  var structures = resource.project_structures.map(function (projectStructure) {
    return {
      name: projectStructure.structure.card_name,
      url: router.resolve({ name: 'Show object', params: { id: projectStructure.structure.id } }).href
    };
  });
  return {
    id: resource.id,
    type: getValue(entity, 'type', resource.type),
    name: resource.name,
    relatedStructures: structures
  };
};

var dashboardNormalizer = function dashboardNormalizer(project) {
  if (project.recent_checklists_items[0]) {
    var recentItems = project.recent_checklists_items;
    project.recent_items = recentItems;

    project.recent_items.forEach(function (item, index) {
      var notes = project.recent_items[index].notes;
      notes = typeof notes === 'string' ? notes.substring(0, 120) : null;
      project.recent_items[index].notes = notes && project.recent_items[index].notes > notes ? notes + '...' : notes;
    });

    delete project.recent_checklists_items;
    return project;
  }
};

var resourceNormalizer_checklistNormalizer = function checklistNormalizer(entity, resource) {
  var ProjectUrl = router.resolve({ name: 'All projects' }).href;
  var StructureUrl = router.resolve({ name: 'All objects' }).href;
  var ChecklistUrl = router.resolve({ name: 'Show inspection', params: { id: resource.id } }).href;
  return {
    id: resource.id,
    type: getValue('project', 'type', resource.type),
    name: resource.name,
    location: resource.location,
    date: luxon["DateTime"].fromISO(resource.updated_at).toLocaleString(luxon["DateTime"].DATETIME_FULL),
    project: "<a href='" + ProjectUrl + "'>" + resource.project.name + '</a>',
    structure: "<a href='" + StructureUrl + "'>" + resource.structure.name + '</a>',
    status: resource.checked,
    checklist_show: "<a href='" + ChecklistUrl + "'>More details</a>",
    defective: resource.defective
  };
};

var structureNormalizer = function structureNormalizer(entity, resource) {
  return {
    id: resource.id,
    type: getValue(entity, 'type', resource.type),
    code: resource.code,
    name: resource.name,
    model: resource.model,
    manufacturer: resource.manufacturer,
    manufacture_year: resource.manufacture_year,
    actionOptions: { 'deleteable': resource.deleteable }
  };
};

var normalizer = function normalizer(entity, resource) {
  switch (entity) {
    case 'user':
      return userNormalizer(entity, resource);
    case 'project':
      return resourceNormalizer_projectNormalizer(entity, resource);
    case 'structure':
      return structureNormalizer(entity, resource);
    case 'checklist':
      return resourceNormalizer_checklistNormalizer(entity, resource);
    case 'dashboard':
      return dashboardNormalizer(resource);
    default:
      return resource;
  }
};


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dashboard.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var Dashboard = ({
  data: function data() {
    return {
      items: [],
      currentPage: null,
      totalPages: null,
      perPage: null,
      totalRows: null,
      nextPage: null,
      prevPage: null,
      sortBy: '',
      sortDesc: false,
      fields: {
        status: { label: 'Status' },
        checklist_show: { label: ' ' },
        checked_at: { label: 'Checked at', class: 'checked_at_table_field', sortable: true },
        component_name: { label: 'Part', sortable: true },
        notes: { label: 'Notes', class: 'notes_table_field' },
        report_number: { label: 'Report number', sortable: true },
        report_file: { label: ' ' }
      }
    };
  },
  mounted: function mounted() {
    var currentPermissions = this.$route.meta.roles;
    if (!policeman.authorize(currentPermissions)) {
      this.showNotification(401);
      this.$route.push({ name: 'Home' });
    }
    this.getResources();
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])({
    currentUser: 'currentUser'
  })),
  watch: {
    currentPage: function currentPage(newPage, oldPage) {
      if (newPage != null && oldPage != null && newPage > 0 && oldPage > 0) {
        var sort = this.$data.sortBy;
        var desc = this.$data.desc;
        this.getResources(newPage, sort, desc);
      }
    }
  },
  methods: {
    projectType: function projectType(key) {
      var type = resourceNormalizer_formatProjectType(key);
      if (typeof type === 'string') {
        return type;
      } else {
        return '';
      }
    },
    getResources: function getResources() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var _this = this;

      var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'updated_at';
      var desc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (sort === null) {
        sort = 'updated_at';
      }
      var route = apiRoutes.index('project');
      var order = desc ? 'desc' : 'asc';
      server.get(route, {
        params: {
          page: page,
          per_page: 20,
          'q[s]': sort + ' ' + order,
          'include': 'recent-checklist-items'
        }
      }).then(function (res) {
        _this.setPager(res.headers);
        var formattedResources = res.data['projects'].filter(function (resource) {
          if (resource.recent_checklists_items) {
            return true;
          }
        }).map(function (resource) {
          return normalizer('dashboard', resource);
        });
        _this.$set(_this.$data, 'items', lodash_default.a.compact(formattedResources));
      }).catch(function (err) {
        console.log(err);
      });
    },
    getIcon: function getIcon(item) {
      if (item.checked_at && item.defective) {
        return 'icon-close text-danger';
      }
      if (!item.checked_at) {
        return 'icon-clock text-warning';
      }
      return 'icon-check text-primary';
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    showNotification: function showNotification(status) {
      return this.showMessage(notificationsMsg.byStatus(status));
    },
    linkGen: function linkGen(pageNum) {
      return { path: '?page=' + pageNum };
    },
    setPager: function setPager(data) {
      this.$set(this.$data, 'nextPage', parseInt(data['x-next-page']));
      this.$set(this.$data, 'prevPage', parseInt(data['x-prev-page']));
      this.$set(this.$data, 'currentPage', parseInt(data['x-page']));
      this.$set(this.$data, 'perPage', parseInt(data['x-per-page']));
      this.$set(this.$data, 'totalRows', parseInt(data['x-total']));
      this.$set(this.$data, 'totalPages', parseInt(data['x-total-pages']));
    },
    sortingChanged: function sortingChanged(variation) {
      this.getResources(this.$data.currentPage, variation.sortBy, variation.sortDesc);
    },
    canGetItemInfo: function canGetItemInfo(item) {
      if (this.currentUser.role === 'customer' && !item.checked) {
        return false;
      }
      return true;
    },
    canGetDraftReport: function canGetDraftReport(item) {
      if (this.currentUser.role === 'customer' || !item.draft_report_url) {
        return false;
      }
      return true;
    },
    canGetFinalReport: function canGetFinalReport(item) {
      if (!item.checked || !item.final_report_url) {
        return false;
      }
      return true;
    }
  },
  notifications: {
    showMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35dfc3bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('h3',{staticClass:"text-primary pt-4 pb-4"},[_vm._v("Recent activities")]),_c('b-row',[_c('b-col',{attrs:{"xs":"12"}},[_vm._l((_vm.items),function(project,index){return [_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion' + index),expression:"'accordion' + index"}],staticClass:"dashboard__btn checklist-item-toggle text-left text-white mt-3",attrs:{"block":"block","href":"#","variant":"primary"}},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(project.name))]),_c('small',[_vm._v(_vm._s(_vm.projectType(project.type)))]),_c('i',{staticClass:"icon-arrow-down accordion-icon"})]),_c('b-collapse',{attrs:{"id":'accordion' + index,"accordion":'accordion' + index,"role":"tabpanel"}},[_c('b-card',[_c('b-table',{staticClass:"table-responsive-sm",attrs:{"hover":"hover","striped":"striped","items":project.recent_items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"checked_at",fn:function(data){return [(_vm.canGetItemInfo(data.item))?_c('div',[_vm._v(_vm._s(data.item.checked_at))]):_c('div',{staticClass:"customer_information"})]}},{key:"component_name",fn:function(data){return _vm.canGetItemInfo(data.item)?[_vm._v(_vm._s(data.item.component_name))]:undefined}},{key:"notes",fn:function(data){return _vm.canGetItemInfo(data.item)?[_vm._v(_vm._s(data.item.notes))]:undefined}},{key:"report_number",fn:function(data){return _vm.canGetItemInfo(data.item)?[_vm._v(_vm._s(data.item.report_number))]:undefined}},{key:"checklist_show",fn:function(data){return _vm.canGetItemInfo(data.item)?[_c('router-link',{staticClass:"text-primary table-action",attrs:{"to":{ name: 'Show inspection', params: { id: data.item.checklist_id } },"title":"View details"}},[_vm._v("View details")])]:undefined}},{key:"status",fn:function(data){return [_c('i',{staticClass:"font-weight-bold",class:_vm.getIcon(data.item)})]}},{key:"report_file",fn:function(data){return _vm.canGetItemInfo(data.item)?[(_vm.canGetDraftReport(data.item))?[_c('b-button',{staticClass:"mb-3 text-white",attrs:{"variant":"warning","type":"button","href":data.item.draft_report_url,"target":"_blank","disabled":(data.item.draft_report_url ? false : true)}},[_vm._v("Download draft report")]),_c('br')]:_vm._e(),(_vm.canGetFinalReport(data.item))?[(_vm.canGetFinalReport(data.item))?_c('b-button',{attrs:{"variant":"primary","type":"button","href":data.item.final_report_url,"target":"_blank","disabled":(data.item.final_report_url ? false : true)}},[_vm._v("Download final report")]):_vm._e()]:_vm._e()]:undefined}}])})],1)],1)]}),_c('nav',{staticClass:"pt-5"},[_c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":_vm.totalPages,"prev-text":"Prev","next-text":"Next"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],2)],1)],1)}
var Dashboard_staticRenderFns = []
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var components_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/Dashboard.vue
function Dashboard_injectStyle (ssrContext) {
  __webpack_require__("TxnN")
}
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = Dashboard_injectStyle
/* scopeId */
var Dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  components_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var src_components_Dashboard = (Dashboard_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/TableActions.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var TableActions = ({
  name: 'TableActions',
  data: function data() {
    return {
      entity: this.$route.meta.entity,
      entityName: '',
      url: this.$route.path,
      actions: {
        show: false,
        edit: false,
        ban: false,
        delete: false
      }
    };
  },

  props: {
    id: {
      type: Number,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    this.$set(this.$data, 'entityName', this.getEntityName());
    var currentActions = policeman.permitActions(this.$data.entity);
    this.$set(this.$data, 'actions', currentActions);
  },

  methods: {
    getEntityName: function getEntityName() {
      switch (this.$route.meta.entity) {
        case 'structure':
          return 'object';
        case 'checklist':
          return 'inspection';
        default:
          return this.$route.meta.entity;
      }
    },
    showTitle: function showTitle() {
      if (this.$data.entityName === 'inspection') {
        return 'report';
      }
      return 'show';
    },
    deleteAlert: function deleteAlert() {
      var _this = this;

      if (confirm('Do you want to delete this ' + this.entityName + '?')) {
        var url = apiRoutes.delete(this.entity, this.id);
        server.delete(url).then(function (res) {
          _this.showNotification(200, 'deleted');
          location.reload();
        }).catch(function (err) {
          _this.showNotification(err.response.status);
        });
      }
    },
    cantDeleteAlert: function cantDeleteAlert() {
      alert('WARNING: This Object cannot be removed because it has already been used in a project');
    },
    showNotification: function showNotification(status) {
      return this.showMessage(notificationsMsg.byStatus(status));
    }
  },
  notifications: {
    showMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e91ed52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/TableActions.vue
var TableActions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.actions.show)?_c('span',{staticClass:"px-2"},[_c('router-link',{staticClass:"text-dark table-action",attrs:{"to":{ name: 'Show ' + _vm.entityName, params: { id: _vm.id }  },"title":_vm.showTitle()}},[_c('i',{staticClass:"table-action__icon icon-doc"})])],1):_vm._e(),(_vm.actions.edit)?_c('span',{staticClass:"px-2"},[_c('router-link',{staticClass:"text-primary table-action",attrs:{"to":{ name: 'Edit ' + _vm.entityName, params: { id: _vm.id } },"title":"edit"}},[_c('i',{staticClass:"table-action__icon icon-note"})])],1):_vm._e(),(_vm.actions.ban)?_c('span',{staticClass:"px-2"},[_c('router-link',{staticClass:"text-warning table-action",attrs:{"to":{ name: 'Home' },"title":"ban"}},[_c('i',{staticClass:"table-action__icon icon-ban"})])],1):_vm._e(),(_vm.actions.delete)?_c('span',{staticClass:"px-2"},[(_vm.options.deleteable)?_c('a',{staticClass:"text-danger table-action",attrs:{"title":"delete"},on:{"click":function($event){_vm.deleteAlert()}}},[_c('i',{staticClass:"table-action__icon icon-trash"})]):_c('a',{staticClass:"table-action undeleteable",attrs:{"title":"delete"},on:{"click":function($event){_vm.cantDeleteAlert()}}},[_c('i',{staticClass:"table-action__icon icon-trash",attrs:{"title":"delete"}})])]):_vm._e()])}
var TableActions_staticRenderFns = []
var TableActions_esExports = { render: TableActions_render, staticRenderFns: TableActions_staticRenderFns }
/* harmony default export */ var Shared_TableActions = (TableActions_esExports);
// CONCATENATED MODULE: ./src/components/Shared/TableActions.vue
function TableActions_injectStyle (ssrContext) {
  __webpack_require__("gLfg")
}
var TableActions_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var TableActions___vue_template_functional__ = false
/* styles */
var TableActions___vue_styles__ = TableActions_injectStyle
/* scopeId */
var TableActions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var TableActions___vue_module_identifier__ = null
var TableActions_Component = TableActions_normalizeComponent(
  TableActions,
  Shared_TableActions,
  TableActions___vue_template_functional__,
  TableActions___vue_styles__,
  TableActions___vue_scopeId__,
  TableActions___vue_module_identifier__
)

/* harmony default export */ var components_Shared_TableActions = (TableActions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/IndexTable.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var IndexTable_pluralize = __webpack_require__("DbJJ");

/* harmony default export */ var IndexTable = ({
  name: 'IndexTable',
  components: { cTableActions: components_Shared_TableActions },
  data: function data() {
    return {
      entity: this.$route.meta.entity,
      entityParams: {},
      items: [],
      currentPage: null,
      totalPages: null,
      perPage: null,
      totalRows: null,
      nextPage: null,
      prevPage: null,
      sortBy: 'created_at',
      sortDesc: true
    };
  },

  props: {
    fields: {
      type: Object,
      default: {}
    },
    initialSortBy: {
      type: String,
      default: 'created_at'
    },
    initialSortDesc: {
      type: Boolean,
      default: true
    },
    initialEntity: {
      type: String,
      default: null
    },
    initialEntityParams: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    var currentPermissions = this.$route.meta.roles;
    if (!policeman.authorize(currentPermissions)) {
      this.showNotification(401);
      this.$route.push({ name: 'Home' });
    }
    if (this.initialEntity) {
      this.$set(this.$data, 'entity', this.initialEntity);
    }
    if (this.initialEntityParams) {
      this.$set(this.$data, 'entityParams', this.initialEntityParams);
    }
    this.$set(this.$data, 'sortBy', this.initialSortBy);
    this.$set(this.$data, 'sortDesc', this.initialSortDesc);
    this.getResources(1, this.initialSortBy, this.initialSortDesc, {});
  },

  watch: {
    currentPage: function currentPage(newPage, oldPage) {
      if (newPage != null && oldPage != null && newPage > 0 && oldPage > 0) {
        var sort = this.$data.sortBy;
        var desc = this.$data.desc;
        this.getResources(newPage, sort, desc);
      }
    }
  },
  methods: {
    getResources: function getResources() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'created_at';

      var _this = this;

      var desc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var otherParams = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if (sort === null) {
        sort = 'created_at';
      }
      var route = apiRoutes.index(this.entity);
      var order = desc ? 'desc' : 'asc';
      var parameters = assign_default()({ page: page, 'q[s]': sort + ' ' + order }, this.entityParams, otherParams);
      server.get(route, { params: parameters }).then(function (res) {
        _this.setPager(res.headers);
        var formattedResources = res.data[IndexTable_pluralize(_this.entity)].map(function (resource) {
          return normalizer(_this.entity, resource);
        });
        _this.$set(_this.$data, 'items', formattedResources);
      }).catch(function (err) {
        console.log(err);
      });
    },
    statusText: function statusText(item) {
      if (item.status) {
        if (item.defective) {
          return 'defect';
        }
        return 'completed';
      }
      return 'in progress';
    },
    getBadge: function getBadge(item) {
      if (item.status) {
        if (item.defective) {
          return 'danger';
        }
        return 'success';
      }
      return 'warning';
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    showNotification: function showNotification(status) {
      return this.showMessage(notificationsMsg.byStatus(status));
    },
    linkGen: function linkGen(pageNum) {
      return { path: '?page=' + pageNum };
    },
    setPager: function setPager(data) {
      this.$set(this.$data, 'nextPage', parseInt(data['x-next-page']));
      this.$set(this.$data, 'prevPage', parseInt(data['x-prev-page']));
      this.$set(this.$data, 'currentPage', parseInt(data['x-page']));
      this.$set(this.$data, 'perPage', parseInt(data['x-per-page']));
      this.$set(this.$data, 'totalRows', parseInt(data['x-total']));
      this.$set(this.$data, 'totalPages', parseInt(data['x-total-pages']));
    },
    sortingChanged: function sortingChanged(variation) {
      this.getResources(this.$data.currentPage, variation.sortBy, variation.sortDesc);
    },
    filteredResources: function filteredResources(filterParams) {
      this.getResources(1, 'created_at', true, filterParams);
    }
  },
  notifications: {
    showMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32bb46f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/IndexTable.vue
var IndexTable_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{staticClass:"table-responsive-sm",attrs:{"hover":"hover","striped":"striped","items":_vm.items,"fields":_vm.fields,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"sort-changed":_vm.sortingChanged},scopedSlots:_vm._u([{key:"status",fn:function(data){return [_c('b-badge',{attrs:{"variant":_vm.getBadge(data.item)}},[_vm._v(_vm._s(_vm.statusText(data.item)))])]}},{key:"relatedStructures",fn:function(data){return _vm._l((data.item.relatedStructures),function(structure){return _c('b-link',{key:structure.url,attrs:{"href":structure.url}},[_c('b-badge',{staticClass:"mr-2",attrs:{"variant":"primary"}},[_vm._v(_vm._s(structure.name))]),_c('br')],1)})}},{key:"actions",fn:function(data){return [_c('c-table-actions',{attrs:{"id":data.item.id,"options":data.item.actionOptions}})]}}])}),_c('nav',[_c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":_vm.totalPages,"prev-text":"Prev","next-text":"Next"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)}
var IndexTable_staticRenderFns = []
var IndexTable_esExports = { render: IndexTable_render, staticRenderFns: IndexTable_staticRenderFns }
/* harmony default export */ var Shared_IndexTable = (IndexTable_esExports);
// CONCATENATED MODULE: ./src/components/Shared/IndexTable.vue
var IndexTable_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var IndexTable___vue_template_functional__ = false
/* styles */
var IndexTable___vue_styles__ = null
/* scopeId */
var IndexTable___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var IndexTable___vue_module_identifier__ = null
var IndexTable_Component = IndexTable_normalizeComponent(
  IndexTable,
  Shared_IndexTable,
  IndexTable___vue_template_functional__,
  IndexTable___vue_styles__,
  IndexTable___vue_scopeId__,
  IndexTable___vue_module_identifier__
)

/* harmony default export */ var components_Shared_IndexTable = (IndexTable_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/CreateEntity.vue
//
//
//
//
//



/* harmony default export */ var CreateEntity = ({
  name: 'CreateEntity',
  props: {
    entity: {
      type: String,
      default: null
    },
    newEntityBtn: {
      type: String,
      default: ''
    },
    newEntityRouteName: {
      type: String,
      default: ''
    }
  },
  methods: {
    canCreate: function canCreate() {
      return policeman.can('new', this.entity);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96f68582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/CreateEntity.vue
var CreateEntity_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canCreate())?_c('b-col',{staticClass:"text-right",attrs:{"xs":"2"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: _vm.newEntityRouteName }}},[_vm._v(_vm._s(_vm.newEntityBtn))])],1):_vm._e()}
var CreateEntity_staticRenderFns = []
var CreateEntity_esExports = { render: CreateEntity_render, staticRenderFns: CreateEntity_staticRenderFns }
/* harmony default export */ var Shared_CreateEntity = (CreateEntity_esExports);
// CONCATENATED MODULE: ./src/components/Shared/CreateEntity.vue
var CreateEntity_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var CreateEntity___vue_template_functional__ = false
/* styles */
var CreateEntity___vue_styles__ = null
/* scopeId */
var CreateEntity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var CreateEntity___vue_module_identifier__ = null
var CreateEntity_Component = CreateEntity_normalizeComponent(
  CreateEntity,
  Shared_CreateEntity,
  CreateEntity___vue_template_functional__,
  CreateEntity___vue_styles__,
  CreateEntity___vue_scopeId__,
  CreateEntity___vue_module_identifier__
)

/* harmony default export */ var components_Shared_CreateEntity = (CreateEntity_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/User/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Index = ({
  name: 'UserIndex',
  components: { cIndexTable: components_Shared_IndexTable, cCreateEntity: components_Shared_CreateEntity },
  data: function data() {
    return {
      entity: 'user',
      tableTitle: 'Users',
      newEntityBtn: 'New user',
      newEntityRouteName: 'New user',
      fields: {
        id: { label: 'ID' },
        first_name: { label: 'First name', sortable: true },
        last_name: { label: 'Last name', sortable: true },
        email: { label: 'Email', sortable: true },
        company: { label: 'Company', sortable: true },
        role: { label: 'Role' },
        actions: { label: 'Actions' }
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63aa7d47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Index.vue
var Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"xs":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"xs":"10"}},[_c('strong',[_vm._v(_vm._s(_vm.tableTitle))]),_c('small',{staticClass:"pl-2"},[_vm._v("Collection")])]),_c('c-create-entity',{attrs:{"entity":_vm.entity,"newEntityBtn":_vm.newEntityBtn,"newEntityRouteName":_vm.newEntityRouteName}})],1)],1),_c('c-index-table',{attrs:{"fields":_vm.fields}})],1)],1)],1)}
var Index_staticRenderFns = []
var Index_esExports = { render: Index_render, staticRenderFns: Index_staticRenderFns }
/* harmony default export */ var User_Index = (Index_esExports);
// CONCATENATED MODULE: ./src/components/User/Index.vue
var Index_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Index___vue_template_functional__ = false
/* styles */
var Index___vue_styles__ = null
/* scopeId */
var Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Index___vue_module_identifier__ = null
var Index_Component = Index_normalizeComponent(
  Index,
  User_Index,
  Index___vue_template_functional__,
  Index___vue_styles__,
  Index___vue_scopeId__,
  Index___vue_module_identifier__
)

/* harmony default export */ var components_User_Index = (Index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/User/Form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Form = ({
  name: 'UserForm',
  data: function data() {
    return {
      roleOptions: options['user_role'],
      formName: 'Create a new User',
      validations: {
        password: 'required|min:12'
      },
      user: {
        first_name: '',
        last_name: '',
        company: '',
        email: '',
        password: '',
        password_confirmation: '',
        role: ''
      }
    };
  },

  computed: {
    password_confirmation_rules: function password_confirmation_rules() {
      if (this.$data.user.password) {
        return this.$data.user.password.length ? 'required|confirmed:password' : '';
      }
      return '';
    }
  },
  mounted: function mounted() {
    if (this.isEdit()) {
      this.$set(this.$data, 'formName', "Modify user's informations");
      this.$set(this.$data.validations, 'password', 'min:12');
      this.fetchUser(this.$route.params.id);
    }
  },

  methods: {
    isEdit: function isEdit() {
      return this.$route.params.hasOwnProperty('id');
    },
    fetchUser: function fetchUser(userId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      server.get('/users/' + userId).then(function (res) {
        var user = res.data.user;
        _this.$set(_this.$data.user, 'first_name', user.first_name);
        _this.$set(_this.$data.user, 'last_name', user.last_name);
        _this.$set(_this.$data.user, 'company', user.company);
        _this.$set(_this.$data.user, 'email', user.email);
        _this.$set(_this.$data.user, 'role', user.role);
      }).catch(function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.saveUser(_this2.$route.params.id);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveUser: function saveUser() {
      var _this3 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = apiRoutes.create('user');
      var verb = 'post';
      var messageModifier = 'created';
      if (id) {
        url = apiRoutes.edit('user', id);
        verb = 'patch';
        messageModifier = 'updated';
      }
      server[verb](url, { user: this.$data.user }).then(function (res) {
        _this3.showNotification(201, messageModifier);
        _this3.$router.push({ name: 'All users' });
      }).catch(function (err) {
        _this3.showNotification(err.response.status);
      });
    },
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'User', modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d99a1d3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Form.vue
var Form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.formName))]),_c('small',{staticClass:"pl-2"},[_vm._v("Form")])]),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"First Name"}},[_c('b-form-input',{attrs:{"type":"text","id":"user_first_name","name":"first_name","placeholder":"Enter user's first name"},model:{value:(_vm.user.first_name),callback:function ($$v) {_vm.$set(_vm.user, "first_name", $$v)},expression:"user.first_name"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Last Name"}},[_c('b-form-input',{attrs:{"type":"text","id":"user_last_name","name":"last_name","placeholder":"Enter user's last name"},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.$set(_vm.user, "last_name", $$v)},expression:"user.last_name"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Company"}},[_c('b-form-input',{attrs:{"type":"text","id":"user_company","name":"company","placeholder":"Enter user's company name"},model:{value:(_vm.user.company),callback:function ($$v) {_vm.$set(_vm.user, "company", $$v)},expression:"user.company"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Role"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"plain":true,"options":_vm.roleOptions,"id":"user_role","name":"role"},model:{value:(_vm.user.role),callback:function ($$v) {_vm.$set(_vm.user, "role", $$v)},expression:"user.role"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('role')),expression:"errors.has('role')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('role')))])],1)],1)],1),_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Email"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"type":"email","id":"user_email","name":"email","placeholder":"Enter user's email address"},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('email')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validations.password),expression:"validations.password"}],attrs:{"type":"password","id":"user_password","name":"password","placeholder":"Enter user's password"},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Password Confirmation"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.password_confirmation_rules),expression:"password_confirmation_rules"}],attrs:{"type":"password","id":"user_password_confirmation","name":"password_confirmation","placeholder":"Re-enter user's password"},model:{value:(_vm.user.password_confirmation),callback:function ($$v) {_vm.$set(_vm.user, "password_confirmation", $$v)},expression:"user.password_confirmation"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password_confirmation')),expression:"errors.has('password_confirmation')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])],1)],1)],1)],1),_c('b-col',{staticClass:"py-4",attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Save")])])],1)],1)])],1)}
var Form_staticRenderFns = []
var Form_esExports = { render: Form_render, staticRenderFns: Form_staticRenderFns }
/* harmony default export */ var User_Form = (Form_esExports);
// CONCATENATED MODULE: ./src/components/User/Form.vue
var Form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Form___vue_template_functional__ = false
/* styles */
var Form___vue_styles__ = null
/* scopeId */
var Form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Form___vue_module_identifier__ = null
var Form_Component = Form_normalizeComponent(
  Form,
  User_Form,
  Form___vue_template_functional__,
  Form___vue_styles__,
  Form___vue_scopeId__,
  Form___vue_module_identifier__
)

/* harmony default export */ var components_User_Form = (Form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Project/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Project_Index = ({
  name: 'ProjectIndex',
  components: { cIndexTable: components_Shared_IndexTable, cCreateEntity: components_Shared_CreateEntity },
  data: function data() {
    return {
      entity: 'project',
      tableTitle: 'Projects',
      newEntityBtn: 'New project',
      newEntityRouteName: 'New project',
      fields: {
        id: { label: 'ID' },
        type: { label: 'Type' },
        name: { label: 'Name', sortable: true },
        relatedStructures: { label: 'Objects' },
        actions: { label: 'Actions' }
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75000d3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Index.vue
var Project_Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"xs":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"xs":"10"}},[_c('strong',[_vm._v(_vm._s(_vm.tableTitle))]),_c('small',{staticClass:"pl-2"},[_vm._v("Collection")])]),_c('c-create-entity',{attrs:{"entity":_vm.entity,"newEntityBtn":_vm.newEntityBtn,"newEntityRouteName":_vm.newEntityRouteName}})],1)],1),_c('c-index-table',{attrs:{"fields":_vm.fields}})],1)],1)],1)}
var Project_Index_staticRenderFns = []
var Project_Index_esExports = { render: Project_Index_render, staticRenderFns: Project_Index_staticRenderFns }
/* harmony default export */ var components_Project_Index = (Project_Index_esExports);
// CONCATENATED MODULE: ./src/components/Project/Index.vue
var Project_Index_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Project_Index___vue_template_functional__ = false
/* styles */
var Project_Index___vue_styles__ = null
/* scopeId */
var Project_Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Project_Index___vue_module_identifier__ = null
var Project_Index_Component = Project_Index_normalizeComponent(
  Project_Index,
  components_Project_Index,
  Project_Index___vue_template_functional__,
  Project_Index___vue_styles__,
  Project_Index___vue_scopeId__,
  Project_Index___vue_module_identifier__
)

/* harmony default export */ var src_components_Project_Index = (Project_Index_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.js
var vue_multiselect_min = __webpack_require__("RUzx");
var vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(vue_multiselect_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Project/Form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Project_Form = ({
  name: 'ProjectForm',
  components: { Multiselect: vue_multiselect_min_default.a },
  data: function data() {
    return {
      typeOptions: options['project_type'],
      formName: 'Create a new Project',
      customerLoading: false,
      structuresLoading: false,
      customersList: [],
      structuresList: [],
      currentCustomers: '',
      currentStructures: [],
      project: {
        name: '',
        type: '',
        customer_ids: [],
        structure_ids: []
      }
    };
  },
  mounted: function mounted() {
    if (this.isEdit()) {
      this.$set(this.$data, 'formName', "Modify project's informations");
      this.fetchProject(this.$route.params.id);
    }
  },

  methods: {
    isEdit: function isEdit() {
      return this.$route.params.hasOwnProperty('id');
    },
    getResourcesIds: function getResourcesIds(resources) {
      if (resources) {
        return resources.map(function (resource) {
          return resource.id;
        });
      }
    },
    fetchProject: function fetchProject(projectId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      var route = apiRoutes.show('project', projectId);
      server.get(route).then(function (res) {
        var project = res.data.project;
        _this.$set(_this.$data.project, 'name', project.name);
        _this.$set(_this.$data.project, 'type', project.type);
        _this.$set(_this.$data.project, 'customer_id', project.customer.id);
        _this.$set(_this.$data, 'currentCustomers', project.customers);
        _this.$set(_this.$data.project, 'structure_ids', _this.getResourcesIds(project.structures));
        _this.$set(_this.$data, 'currentStructures', project.structures);
      }).catch(function (err) {
        console.log(err);
      });
    },

    asyncFindCustomers: lodash_default.a.debounce(function (query) {
      var _this2 = this;

      this.customerLoading = true;
      var url = apiRoutes.index('user');
      server.get(url, {
        params: {
          'q[role_eq]': 'customer',
          'q[card_name_cont]': query
        }
      }).then(function (res) {
        _this2.$set(_this2.$data, 'customersList', res.data.users);
        _this2.customerLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.customerLoading = false;
      });
    }, 700),
    asyncFindStructures: lodash_default.a.debounce(function (query) {
      var _this3 = this;

      this.structuresLoading = true;
      var url = apiRoutes.index('structure');
      server.get(url, {
        params: {
          'q[card_name_cont]': query
        }
      }).then(function (res) {
        _this3.$set(_this3.$data, 'structuresList', res.data.structures);
        _this3.structuresLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this3.structuresLoading = true;
      });
    }, 700),
    goToStructuresManagement: function goToStructuresManagement() {
      this.$router.push({ name: 'Project objects management', params: { id: this.$route.params.id } });
    },
    saveGoToStructuresManagement: function saveGoToStructuresManagement() {
      this.submit(true);
    },
    submit: function submit() {
      var _this4 = this;

      var toPermissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this4.saveProject(_this4.$route.params.id, toPermissions);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveProject: function saveProject() {
      var _this5 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var toPermissions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var url = apiRoutes.create('project');
      var verb = 'post';
      var messageModifier = 'created';
      if (id) {
        url = apiRoutes.edit('project', id);
        verb = 'patch';
        messageModifier = 'updated';
      }
      this.$data.project.customer_ids = this.getResourcesIds(this.$data.currentCustomers);
      this.$data.project.structure_ids = this.getResourcesIds(this.$data.currentStructures);
      server[verb](url, { project: this.$data.project }).then(function (res) {
        _this5.showNotification(201, messageModifier);
        if (toPermissions) {
          _this5.$router.push({ name: 'Project objects management', params: { id: res.data.project.id } });
        } else {
          _this5.$router.push({ name: 'All projects' });
        }
      }).catch(function (err) {
        _this5.showNotification(err.response.status);
      });
    },
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Project', modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1512905b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Form.vue
var Project_Form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.formName))]),_c('small',{staticClass:"pl-2"},[_vm._v("Form")])]),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Name"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":"project_name","name":"name","placeholder":"Enter project's name"},model:{value:(_vm.project.name),callback:function ($$v) {_vm.$set(_vm.project, "name", $$v)},expression:"project.name"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('name')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Type"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"plain":true,"options":_vm.typeOptions,"id":"project_type","name":"type"},model:{value:(_vm.project.type),callback:function ($$v) {_vm.$set(_vm.project, "type", $$v)},expression:"project.type"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('type')),expression:"errors.has('type')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('type')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[(!_vm.isEdit())?_c('b-form-fieldset',{staticClass:"pb-0",attrs:{"label":"Customers"}},[_c('small',[_vm._v("Enter here the customers who can view all objects")]),_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"project_customers","name":"customers","multiple":true,"options":_vm.customersList,"loading":_vm.customerLoading,"internal-search":false,"label":"card_name","close-on-select":true,"track-by":"id","placeholder":"Search a customer here"},on:{"search-change":_vm.asyncFindCustomers},model:{value:(_vm.currentCustomers),callback:function ($$v) {_vm.currentCustomers=$$v},expression:"currentCustomers"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('customers')),expression:"errors.has('customers')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('customers')))])],1):_vm._e()],1)],1),_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[(!_vm.isEdit())?_c('b-form-fieldset',{attrs:{"label":"Objects"}},[_c('multiselect',{attrs:{"id":"project_structures","name":"structures","multiple":true,"options":_vm.structuresList,"loading":_vm.structuresLoading,"internal-search":false,"label":"card_name","close-on-select":true,"track-by":"id","placeholder":"Search objects here"},on:{"search-change":_vm.asyncFindStructures},model:{value:(_vm.currentStructures),callback:function ($$v) {_vm.currentStructures=$$v},expression:"currentStructures"}})],1):_vm._e()],1)],1)],1),_c('b-col',{staticClass:"py-4",attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Save")]),(!_vm.isEdit())?_c('button',{staticClass:"btn btn-primary px-4 mx-2",attrs:{"type":"button"},on:{"click":function($event){_vm.saveGoToStructuresManagement()}}},[_vm._v("Save and go to Objects Management")]):_vm._e(),(_vm.isEdit())?_c('button',{staticClass:"btn btn-primary px-4 mx-2",attrs:{"type":"button"},on:{"click":function($event){_vm.goToStructuresManagement()}}},[_vm._v("Objects Management")]):_vm._e()])],1)],1)],1)],1)}
var Project_Form_staticRenderFns = []
var Project_Form_esExports = { render: Project_Form_render, staticRenderFns: Project_Form_staticRenderFns }
/* harmony default export */ var components_Project_Form = (Project_Form_esExports);
// CONCATENATED MODULE: ./src/components/Project/Form.vue
var Project_Form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Project_Form___vue_template_functional__ = false
/* styles */
var Project_Form___vue_styles__ = null
/* scopeId */
var Project_Form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Project_Form___vue_module_identifier__ = null
var Project_Form_Component = Project_Form_normalizeComponent(
  Project_Form,
  components_Project_Form,
  Project_Form___vue_template_functional__,
  Project_Form___vue_styles__,
  Project_Form___vue_scopeId__,
  Project_Form___vue_module_identifier__
)

/* harmony default export */ var src_components_Project_Form = (Project_Form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Project/StructureCustomers.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var StructureCustomers = ({
  name: 'StructureCustomers',
  components: { Multiselect: vue_multiselect_min_default.a },
  data: function data() {
    return {
      customerLoading: false,
      customersList: [],
      projectStructure: {}
    };
  },

  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  mounted: function mounted() {
    this.$set(this.$data, 'projectStructure', this.item);
  },

  methods: {
    getResourcesIds: function getResourcesIds(resources) {
      if (resources) {
        return resources.map(function (resource) {
          return resource.id;
        });
      }
    },
    submit: function submit() {
      this.saveItem(this.item.id);
    },
    saveItem: function saveItem() {
      var _this = this;

      var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = '/project-structures/' + itemId;
      this.$data.projectStructure.customer_ids = this.getResourcesIds(this.$data.projectStructure.customers);
      server.patch(url, { project_structure: this.$data.projectStructure }).then(function (res) {
        _this.showNotification(201, 'updated');
        _this.$set(_this.$data, 'projectStructure', res.data.project_structure);
      }).catch(function (err) {
        _this.showNotification(err.response.status);
      });
    },

    asyncFindCustomers: lodash_default.a.debounce(function (query) {
      var _this2 = this;

      this.customerLoading = true;
      var url = apiRoutes.index('user');
      server.get(url, {
        params: {
          'q[role_eq]': 'customer',
          'q[card_name_cont]': query
        }
      }).then(function (res) {
        _this2.$set(_this2.$data, 'customersList', res.data.users);
        _this2.customerLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.customerLoading = false;
      });
    }, 700),
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Project', modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-512ed186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/StructureCustomers.vue
var StructureCustomers_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('small',[_vm._v("Object")]),_c('h5',[_vm._v(_vm._s(_vm.item.structure.code + " - " + _vm.item.structure.name))])]),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-fieldset',{staticClass:"pb-0",attrs:{"label":"Customers"}},[_c('multiselect',{attrs:{"id":"project_structure_customersundefined","name":"structure_customersundefined","multiple":true,"options":_vm.customersList,"loading":_vm.customerLoading,"internal-search":false,"label":"card_name","close-on-select":true,"track-by":"id","placeholder":"Search a customer here"},on:{"search-change":_vm.asyncFindCustomers},model:{value:(_vm.projectStructure.customers),callback:function ($$v) {_vm.$set(_vm.projectStructure, "customers", $$v)},expression:"projectStructure.customers"}})],1)],1)],1),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Save")])])],1)],1)],1)],1)}
var StructureCustomers_staticRenderFns = []
var StructureCustomers_esExports = { render: StructureCustomers_render, staticRenderFns: StructureCustomers_staticRenderFns }
/* harmony default export */ var Project_StructureCustomers = (StructureCustomers_esExports);
// CONCATENATED MODULE: ./src/components/Project/StructureCustomers.vue
var StructureCustomers_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var StructureCustomers___vue_template_functional__ = false
/* styles */
var StructureCustomers___vue_styles__ = null
/* scopeId */
var StructureCustomers___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StructureCustomers___vue_module_identifier__ = null
var StructureCustomers_Component = StructureCustomers_normalizeComponent(
  StructureCustomers,
  Project_StructureCustomers,
  StructureCustomers___vue_template_functional__,
  StructureCustomers___vue_styles__,
  StructureCustomers___vue_scopeId__,
  StructureCustomers___vue_module_identifier__
)

/* harmony default export */ var components_Project_StructureCustomers = (StructureCustomers_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Project/StructuresManagement.vue
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var StructuresManagement = ({
  name: 'StructuresManagement',
  components: { cStructureCustomers: components_Project_StructureCustomers },
  data: function data() {
    return {
      project: {
        // project_structures: [
        //   {
        //     id: null,
        //     structure: {},
        //     customers: []
        //   }
        // ]
      }
    };
  },
  mounted: function mounted() {
    this.fetchProject(this.$route.params.id);
  },

  methods: {
    fetchProject: function fetchProject(projectId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      var route = apiRoutes.show('project', projectId);
      server.get(route).then(function (res) {
        var project = res.data.project;
        _this.$set(_this.$data, 'project', project);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43660139","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/StructuresManagement.vue
var StructuresManagement_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-primary pt-2 pb-4"},[_vm._v("Objects Management")]),_vm._l((_vm.project.project_structures),function(item,index){return [_c('c-structure-customers',{attrs:{"item":item}})]})],2)}
var StructuresManagement_staticRenderFns = []
var StructuresManagement_esExports = { render: StructuresManagement_render, staticRenderFns: StructuresManagement_staticRenderFns }
/* harmony default export */ var Project_StructuresManagement = (StructuresManagement_esExports);
// CONCATENATED MODULE: ./src/components/Project/StructuresManagement.vue
var StructuresManagement_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var StructuresManagement___vue_template_functional__ = false
/* styles */
var StructuresManagement___vue_styles__ = null
/* scopeId */
var StructuresManagement___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var StructuresManagement___vue_module_identifier__ = null
var StructuresManagement_Component = StructuresManagement_normalizeComponent(
  StructuresManagement,
  Project_StructuresManagement,
  StructuresManagement___vue_template_functional__,
  StructuresManagement___vue_styles__,
  StructuresManagement___vue_scopeId__,
  StructuresManagement___vue_module_identifier__
)

/* harmony default export */ var components_Project_StructuresManagement = (StructuresManagement_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Structure/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Structure_Index = ({
  name: 'StructureIndex',
  components: { cIndexTable: components_Shared_IndexTable, cCreateEntity: components_Shared_CreateEntity },
  data: function data() {
    return {
      entity: 'structure',
      tableTitle: 'Objects',
      newEntityBtn: 'New object',
      newEntityRouteName: 'New object',
      fields: {
        id: { label: 'ID' },
        type: { label: 'Type' },
        name: { label: 'Name', sortable: true },
        model: { label: 'Model', sortable: true },
        code: { label: 'ID Code', sortable: true },
        actions: { label: 'Actions' }
      }
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d23f12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Structure/Index.vue
var Structure_Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"xs":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"xs":"10"}},[_c('strong',[_vm._v(_vm._s(_vm.tableTitle))]),_c('small',{staticClass:"pl-2"},[_vm._v("Collection")])]),_c('c-create-entity',{attrs:{"entity":_vm.entity,"newEntityBtn":_vm.newEntityBtn,"newEntityRouteName":_vm.newEntityRouteName}})],1)],1),_c('c-index-table',{attrs:{"fields":_vm.fields}})],1)],1)],1)}
var Structure_Index_staticRenderFns = []
var Structure_Index_esExports = { render: Structure_Index_render, staticRenderFns: Structure_Index_staticRenderFns }
/* harmony default export */ var components_Structure_Index = (Structure_Index_esExports);
// CONCATENATED MODULE: ./src/components/Structure/Index.vue
var Structure_Index_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Structure_Index___vue_template_functional__ = false
/* styles */
var Structure_Index___vue_styles__ = null
/* scopeId */
var Structure_Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Structure_Index___vue_module_identifier__ = null
var Structure_Index_Component = Structure_Index_normalizeComponent(
  Structure_Index,
  components_Structure_Index,
  Structure_Index___vue_template_functional__,
  Structure_Index___vue_styles__,
  Structure_Index___vue_scopeId__,
  Structure_Index___vue_module_identifier__
)

/* harmony default export */ var src_components_Structure_Index = (Structure_Index_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Structure/Form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Structure_Form = ({
  name: 'StructureForm',
  data: function data() {
    return {
      typeOptions: options['structure_type'],
      formName: 'Create a new Object',
      structure: {
        type: null,
        name: null,
        model: null,
        code: null,
        manufacturer: null,
        manufacture_year: null
      }
    };
  },
  mounted: function mounted() {
    if (this.isEdit()) {
      this.$set(this.$data, 'formName', "Modify object's informations");
      this.fetchStructure(this.$route.params.id);
    }
  },

  methods: {
    isEdit: function isEdit() {
      return this.$route.params.hasOwnProperty('id');
    },
    fetchStructure: function fetchStructure(structureId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      var route = apiRoutes.show('structure', structureId);
      server.get(route).then(function (res) {
        _this.$set(_this.$data, 'structure', res.data.structure);
      }).catch(function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.saveStructure(_this2.$route.params.id);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveStructure: function saveStructure() {
      var _this3 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = apiRoutes.create('structure');
      var verb = 'post';
      var messageModifier = 'created';
      if (id) {
        url = apiRoutes.edit('structure', id);
        verb = 'patch';
        messageModifier = 'updated';
      }
      server[verb](url, { structure: this.$data.structure }).then(function (res) {
        _this3.showNotification(201, messageModifier);
        _this3.$router.push({ name: 'All objects' });
      }).catch(function (err) {
        _this3.showNotification(err.response.status);
      });
    },
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Object', modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd05693","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Structure/Form.vue
var Structure_Form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.formName))]),_c('small',{staticClass:"pl-2"},[_vm._v("Form")])]),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Type"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"plain":true,"options":_vm.typeOptions,"id":"structure_type","name":"type"},model:{value:(_vm.structure.type),callback:function ($$v) {_vm.$set(_vm.structure, "type", $$v)},expression:"structure.type"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('type')),expression:"errors.has('type')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('type')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Name"}},[_c('b-form-input',{attrs:{"type":"text","id":"structure_name","name":"name","placeholder":"Enter object's name"},model:{value:(_vm.structure.name),callback:function ($$v) {_vm.$set(_vm.structure, "name", $$v)},expression:"structure.name"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Model"}},[_c('b-form-input',{attrs:{"type":"text","id":"structure_model","name":"model","placeholder":"Enter object's model"},model:{value:(_vm.structure.model),callback:function ($$v) {_vm.$set(_vm.structure, "model", $$v)},expression:"structure.model"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"ID Code"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":"structure_code","name":"code","placeholder":"Enter object's ID Code"},model:{value:(_vm.structure.code),callback:function ($$v) {_vm.$set(_vm.structure, "code", $$v)},expression:"structure.code"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('code')),expression:"errors.has('code')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('code')))])],1)],1)],1),_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Manufacturer"}},[_c('b-form-input',{attrs:{"type":"text","id":"structure_manufacturer","name":"manufacturer","placeholder":"Enter object's manufacturer"},model:{value:(_vm.structure.manufacturer),callback:function ($$v) {_vm.$set(_vm.structure, "manufacturer", $$v)},expression:"structure.manufacturer"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Year of manufacture"}},[_c('b-form-input',{attrs:{"type":"number","id":"structure_manufacture_year","name":"manufacture_year"},model:{value:(_vm.structure.manufacture_year),callback:function ($$v) {_vm.$set(_vm.structure, "manufacture_year", $$v)},expression:"structure.manufacture_year"}})],1)],1)],1)],1),_c('b-col',{staticClass:"py-4",attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Save")])])],1)],1)],1)],1)}
var Structure_Form_staticRenderFns = []
var Structure_Form_esExports = { render: Structure_Form_render, staticRenderFns: Structure_Form_staticRenderFns }
/* harmony default export */ var components_Structure_Form = (Structure_Form_esExports);
// CONCATENATED MODULE: ./src/components/Structure/Form.vue
var Structure_Form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Structure_Form___vue_template_functional__ = false
/* styles */
var Structure_Form___vue_styles__ = null
/* scopeId */
var Structure_Form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Structure_Form___vue_module_identifier__ = null
var Structure_Form_Component = Structure_Form_normalizeComponent(
  Structure_Form,
  components_Structure_Form,
  Structure_Form___vue_template_functional__,
  Structure_Form___vue_styles__,
  Structure_Form___vue_scopeId__,
  Structure_Form___vue_module_identifier__
)

/* harmony default export */ var src_components_Structure_Form = (Structure_Form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Structure/Show.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Show = ({
  name: 'StructureShow',
  components: { cIndexTable: components_Shared_IndexTable },
  data: function data() {
    return {
      structure: {},
      checklists: [],
      checklistFields: {
        id: { label: 'ID' },
        status: { label: 'Status' },
        name: { label: 'Name', sortable: true },
        project: { label: 'Project' },
        location: { label: 'Location' },
        date: { label: 'Date', sortable: true },
        checklist_show: { label: ' ' }
      },
      checklistParams: {
        per_page: 10,
        'q[structure_id_eq]': this.$route.params.id
      }
    };
  },
  mounted: function mounted() {
    var currentPermissions = this.$route.meta.roles;
    if (!policeman.authorize(currentPermissions)) {
      this.showNotification(401);
      this.$route.push({ name: 'Home' });
    }
    this.fetchStructure(this.$route.params.id);
  },

  methods: {
    fetchStructure: function fetchStructure(structureId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      var route = apiRoutes.show('structure', structureId);
      server.get(route).then(function (res) {
        _this.$set(_this.$data, 'structure', res.data.structure);
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54987e7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Structure/Show.vue
var Show_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',{attrs:{"header":"Object's details"}},[_c('b-row',{staticClass:"pb-2"},[_c('b-col',{staticClass:"d-none d-sm-block",attrs:{"sm":"2"}},[_c('div',{staticClass:"structure-logo",class:_vm.structure.type + '-logo'})]),_c('b-col',{attrs:{"sm":"10"}},[_c('h3',[_vm._v(_vm._s(_vm.structure.name))]),_c('strong',{staticClass:"pr-2"},[_vm._v("Model:")]),_c('span',[_vm._v(_vm._s(_vm.structure.model))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Code:")]),_c('span',[_vm._v(_vm._s(_vm.structure.code))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Manufaturer:")]),_c('span',[_vm._v(_vm._s(_vm.structure.manufacturer))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Year of manufacture:")]),_c('span',[_vm._v(_vm._s(_vm.structure.manufacture_year))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Registered at:")]),_c('span',[_vm._v(_vm._s(_vm.structure.created_at))])])],1)],1),_c('b-card',{attrs:{"header":"Past activities"}},[_c('c-index-table',{attrs:{"fields":_vm.checklistFields,"initialEntity":"checklist","initialEntityParams":_vm.checklistParams}})],1)],1)],1)}
var Show_staticRenderFns = []
var Show_esExports = { render: Show_render, staticRenderFns: Show_staticRenderFns }
/* harmony default export */ var Structure_Show = (Show_esExports);
// CONCATENATED MODULE: ./src/components/Structure/Show.vue
function Show_injectStyle (ssrContext) {
  __webpack_require__("TGU3")
}
var Show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Show___vue_template_functional__ = false
/* styles */
var Show___vue_styles__ = Show_injectStyle
/* scopeId */
var Show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Show___vue_module_identifier__ = null
var Show_Component = Show_normalizeComponent(
  Show,
  Structure_Show,
  Show___vue_template_functional__,
  Show___vue_styles__,
  Show___vue_scopeId__,
  Show___vue_module_identifier__
)

/* harmony default export */ var components_Structure_Show = (Show_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checklist/Index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var Checklist_Index = ({
  name: 'ChecklistIndex',
  components: { cIndexTable: components_Shared_IndexTable, cCreateEntity: components_Shared_CreateEntity, Multiselect: vue_multiselect_min_default.a },
  data: function data() {
    return {
      entity: 'checklist',
      tableTitle: 'Inspections',
      newEntityBtn: "New inspection's batch",
      newEntityRouteName: 'New inspection',
      fields: {
        id: { label: 'ID' },
        name: { label: 'Inspection', sortable: true },
        project: { label: 'Project' },
        structure: { label: 'Object' },
        location: { label: 'Location' },
        date: { label: 'Date', sortable: true },
        status: { label: 'Status' },
        actions: { label: 'Actions' }
      },
      search: {
        currentProject: '',
        currentStructure: '',
        projectsList: [],
        structuresList: [],
        projectLoading: false,
        structureLoading: false
      }
    };
  },
  methods: {
    asyncFindProjects: lodash_default.a.debounce(function (query) {
      var _this = this;

      this.search.projectLoading = true;
      var url = apiRoutes.index('project');
      server.get(url, {
        params: {
          'q[name_cont]': query
        }
      }).then(function (res) {
        _this.$set(_this.$data.search, 'projectsList', res.data.projects);
        _this.search.projectLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this.search.projectLoading = false;
      });
    }, 700),
    asyncFindStructures: lodash_default.a.debounce(function (query) {
      var _this2 = this;

      this.search.structuresLoading = true;
      var url = apiRoutes.index('structure');
      server.get(url, {
        params: {
          'q[card_name_cont]': query
        }
      }).then(function (res) {
        _this2.$set(_this2.$data.search, 'structuresList', res.data.structures);
        _this2.search.structuresLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.search.structuresLoading = true;
      });
    }, 700),
    startSearch: function startSearch() {
      var filterParams = {
        'q[project_name_cont]': this.search.currentProject ? this.search.currentProject.name : '',
        'q[structure_name_cont]': this.search.currentStructure ? this.search.currentStructure.name : '',
        'q[location_cont]': this.search.location,
        'q[checklist_items_name_cont]': this.search.part
      };
      this.$refs.indexTable.filteredResources(filterParams);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-170df193","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist/Index.vue
var Checklist_Index_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"xs":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search")])]),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Project"}},[_c('multiselect',{attrs:{"id":"search_project","name":"search_project","options":_vm.search.projectsList,"loading":_vm.search.projectLoading,"internal-search":false,"label":"name","close-on-select":true,"clear-on-select":true,"track-by":"id"},on:{"search-change":_vm.asyncFindProjects},model:{value:(_vm.search.currentProject),callback:function ($$v) {_vm.$set(_vm.search, "currentProject", $$v)},expression:"search.currentProject"}})],1)],1),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Object"}},[_c('multiselect',{attrs:{"id":"search_structure","name":"search_structure","options":_vm.search.structuresList,"loading":_vm.search.structureLoading,"internal-search":false,"label":"card_name","close-on-select":true,"clear-on-select":true,"track-by":"id"},on:{"search-change":_vm.asyncFindStructures},model:{value:(_vm.search.currentStructure),callback:function ($$v) {_vm.$set(_vm.search, "currentStructure", $$v)},expression:"search.currentStructure"}})],1)],1),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-fieldset',{attrs:{"label":"Location"}},[_c('b-form-input',{attrs:{"type":"text","id":"search_checklist_location","name":"search_checklist_location"},model:{value:(_vm.search.location),callback:function ($$v) {_vm.$set(_vm.search, "location", $$v)},expression:"search.location"}})],1)],1),_c('b-col',{attrs:{"sm":"2","md":"3"}},[_c('b-form-fieldset',{attrs:{"label":"Part"}},[_c('b-form-input',{attrs:{"type":"text","id":"search_checklist_item_part","name":"search_checklist_item_part"},model:{value:(_vm.search.part),callback:function ($$v) {_vm.$set(_vm.search, "part", $$v)},expression:"search.part"}})],1)],1),_c('b-col',{attrs:{"sm":"2","md":"1"}},[_c('button',{staticClass:"btn btn-primary search-btn",attrs:{"type":"button","title":"search"},on:{"click":function($event){_vm.startSearch()}}},[_c('i',{staticClass:"d-none d-sm-block strong icon-magnifier"}),_c('span',{staticClass:"d-block d-sm-none"},[_vm._v("Search")])])])],1)],1)],1)],1)],1)],1)],1),_c('b-row',[_c('b-col',{attrs:{"xs":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"xs":"10"}},[_c('strong',[_vm._v(_vm._s(_vm.tableTitle))]),_c('small',{staticClass:"pl-2"},[_vm._v("Collection")])]),_c('c-create-entity',{attrs:{"entity":_vm.entity,"newEntityBtn":_vm.newEntityBtn,"newEntityRouteName":_vm.newEntityRouteName}})],1)],1),_c('c-index-table',{ref:"indexTable",attrs:{"fields":_vm.fields,"initialSortBy":"updated_at"}})],1)],1)],1)],1)}
var Checklist_Index_staticRenderFns = []
var Checklist_Index_esExports = { render: Checklist_Index_render, staticRenderFns: Checklist_Index_staticRenderFns }
/* harmony default export */ var components_Checklist_Index = (Checklist_Index_esExports);
// CONCATENATED MODULE: ./src/components/Checklist/Index.vue
function Index_injectStyle (ssrContext) {
  __webpack_require__("oDVn")
}
var Checklist_Index_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Checklist_Index___vue_template_functional__ = false
/* styles */
var Checklist_Index___vue_styles__ = Index_injectStyle
/* scopeId */
var Checklist_Index___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Checklist_Index___vue_module_identifier__ = null
var Checklist_Index_Component = Checklist_Index_normalizeComponent(
  Checklist_Index,
  components_Checklist_Index,
  Checklist_Index___vue_template_functional__,
  Checklist_Index___vue_styles__,
  Checklist_Index___vue_scopeId__,
  Checklist_Index___vue_module_identifier__
)

/* harmony default export */ var src_components_Checklist_Index = (Checklist_Index_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-carousel/dist/vue-carousel.min.js
var vue_carousel_min = __webpack_require__("/kJX");
var vue_carousel_min_default = /*#__PURE__*/__webpack_require__.n(vue_carousel_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checklist/subcomponents/ShowItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ShowItem = ({
  name: 'ShowItem',
  components: { Carousel: vue_carousel_min["Carousel"], Slide: vue_carousel_min["Slide"] },
  data: function data() {
    return {
      carousel: {
        autoplay: true,
        autoplayTimeout: 3000,
        perPage: 1,
        navigationEnabled: true
      },
      currentStatus: 'warning',
      iconClass: 'icon-clock'
    };
  },

  props: {
    index: {
      type: Number,
      default: null
    },
    checklistItem: {
      type: Object,
      default: {}
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])({
    currentUser: 'currentUser'
  })),
  mounted: function mounted() {
    this.itemStatus();
  },

  methods: {
    itemStatus: function itemStatus() {
      var variant = 'warning';
      var icon = 'icon-clock';
      if (this.checklistItem.checked) {
        variant = 'primary';
        icon = 'icon-check';
        if (this.checklistItem.defective) {
          variant = 'danger';
          icon = 'icon-close';
        }
      }
      this.$set(this.$data, 'currentStatus', variant);
      this.$set(this.$data, 'iconClass', icon);
    },
    canGetDraftReport: function canGetDraftReport() {
      if (this.currentUser.role === 'customer' || !this.checklistItem.draft_report_url) {
        return false;
      }
      return true;
    },
    cannotGetFinalReport: function cannotGetFinalReport() {
      if (this.checklistItem.checked && this.checklistItem.final_report_url) {
        return false;
      }
      return true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e486fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist/subcomponents/ShowItem.vue
var ShowItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion' + _vm.index),expression:"'accordion' + index"}],staticClass:"checklist-item-toggle text-left text-white mt-3",attrs:{"block":"block","href":"#","variant":_vm.currentStatus}},[_c('i',{staticClass:"font-weight-bold pr-2",class:_vm.iconClass}),_c('span',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.checklistItem.name))]),_c('i',{staticClass:"icon-arrow-down accordion-icon"})]),_c('b-collapse',{attrs:{"id":'accordion' + _vm.index,"accordion":'accordion' + _vm.index,"role":"tabpanel"}},[_c('b-card',[(!_vm.checklistItem.checked)?[_c('b-card-body',[_c('b-row',{staticClass:"py-2"},[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"font-weight-bold text-secondary mt-3"},[_c('h3',[_c('i',{staticClass:"icon-clock pr-2"}),_c('span',[_vm._v("The operator has not completed the check yet")])])])])],1)],1)]:_vm._e(),(_vm.checklistItem.checked)?[_c('b-card-body',[_c('b-row',{staticClass:"py-2"},[_c('b-col',{attrs:{"sm":"6"}},[_c('strong',{staticClass:"pr-2"},[_vm._v("Related component:")]),_c('span',[_vm._v(_vm._s(_vm.checklistItem.component_name))]),(_vm.checklistItem.defective)?_c('span',{staticClass:"text-danger pl-2"},[_c('small',[_vm._v("defective")])]):_vm._e(),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Operator:")]),_c('span',[_vm._v(_vm._s((_vm.checklistItem.checker) ? _vm.checklistItem.checker.full_name : null))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Evasion date:")]),_c('span',[_vm._v(_vm._s(_vm.checklistItem.checked_at))])]),_c('b-col',{attrs:{"sm":"6"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('p',[_vm._v("Report number: "+_vm._s(_vm.checklistItem.report_number ? _vm.checklistItem.report_number : 'not registered'))])])],1),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.canGetDraftReport())?[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary","type":"button","href":_vm.checklistItem.draft_report_url}},[_vm._v("Download draft report")])]:_vm._e(),_c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary","type":"button","href":_vm.checklistItem.final_report_url,"disabled":_vm.cannotGetFinalReport()}},[_vm._v("Download final report")])],2)],1)],1)],1),_c('b-row',{staticClass:"py-2"},[_c('b-col',{attrs:{"sm":"6"}},[(_vm.checklistItem.notes)?[_c('strong',{staticClass:"pr-2"},[_vm._v("Activity notes:")]),_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.checklistItem.notes))])]:_vm._e(),(_vm.checklistItem.grid_of_inspection)?[_c('strong',{staticClass:"pr-2"},[_vm._v("Grid of inspection:")]),_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.checklistItem.grid_of_inspection))])]:_vm._e(),(_vm.checklistItem.instrumental_settings)?[_c('strong',{staticClass:"pr-2"},[_vm._v("Instrumental settings:")]),_c('p',{staticClass:"mt-2"},[_vm._v(_vm._s(_vm.checklistItem.instrumental_settings))])]:_vm._e()],2),_c('b-col',{attrs:{"sm":"6"}},[_c('strong',{staticClass:"pr-2"},[_vm._v("Photos:")]),(_vm.checklistItem.photos.length > 0)?[_c('carousel',{staticClass:"mt-2",attrs:{"autoplay":_vm.carousel.autoplay,"autoplayTimeout":_vm.carousel.autoplayTimeout,"perPage":_vm.carousel.perPage,"navigationEnabled":_vm.carousel.navigationEnabled}},[_vm._l((_vm.checklistItem.photo_urls),function(url,key){return [_c('slide',[_c('a',{attrs:{"href":url,"target":"_blank"}},[_c('b-img',{attrs:{"src":url,"fluid":"fluid"}})],1)])]})],2)]:_vm._e(),(_vm.checklistItem.photos.length <= 0)?[_c('div',{staticClass:"font-weight-bold text-secondary mt-3"},[_c('h3',[_c('i',{staticClass:"icon-exclamation pr-2"}),_c('span',[_vm._v("No photos were uploaded")])])])]:_vm._e()],2)],1)],1)]:_vm._e()],2)],1)],1)}
var ShowItem_staticRenderFns = []
var ShowItem_esExports = { render: ShowItem_render, staticRenderFns: ShowItem_staticRenderFns }
/* harmony default export */ var subcomponents_ShowItem = (ShowItem_esExports);
// CONCATENATED MODULE: ./src/components/Checklist/subcomponents/ShowItem.vue
var ShowItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ShowItem___vue_template_functional__ = false
/* styles */
var ShowItem___vue_styles__ = null
/* scopeId */
var ShowItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ShowItem___vue_module_identifier__ = null
var ShowItem_Component = ShowItem_normalizeComponent(
  ShowItem,
  subcomponents_ShowItem,
  ShowItem___vue_template_functional__,
  ShowItem___vue_styles__,
  ShowItem___vue_scopeId__,
  ShowItem___vue_module_identifier__
)

/* harmony default export */ var Checklist_subcomponents_ShowItem = (ShowItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checklist/Show.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Checklist_Show = ({
  name: 'ChecklistShow',
  components: { cChecklistItem: Checklist_subcomponents_ShowItem },
  data: function data() {
    return {
      isAdmin: policeman.isAdmin(),
      checklist: {
        project: {},
        structure: {}
      }
    };
  },
  mounted: function mounted() {
    this.fetchChecklist(this.$route.params.id);
  },

  methods: {
    fetchChecklist: function fetchChecklist(checklistId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      var route = apiRoutes.show('checklist', checklistId);
      server.get(route).then(function (res) {
        var checklist = res.data.checklist;
        _this.$set(_this.$data, 'checklist', checklist);
      }).catch(function (err) {
        console.log(err);
      });
    },
    generateQuickReport: function generateQuickReport() {
      var _this2 = this;

      if (confirm('Are you sure you want to proceed?\nWe will generate the report and send you an email to download it')) {
        var checklistId = this.$route.params.id;
        var route = apiRoutes.show('checklist', checklistId) + '/quick_report';
        server.get(route).then(function (res) {
          _this2.showNotification(201, 'created', 'Quick report');
        }).catch(function (err) {
          _this2.showNotification(err.response.status);
        });
      }
    },
    updateRevised: function updateRevised() {
      if (this.isAdmin) {
        this.saveRevised(this.$route.params.id);
      }
    },
    saveRevised: function saveRevised() {
      var _this3 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = apiRoutes.edit('checklist', id) + '/revise';
      var messageModifier = 'updated';
      this.$set(this.$data.checklist, 'revised', !this.$data.checklist.revised);
      server.patch(url, { checklist: this.$data.checklist }).then(function (res) {
        _this3.showNotification(201, messageModifier);
        _this3.$set(_this3.$data, 'checklist', res.data.checklist);
      }).catch(function (err) {
        _this3.showNotification(err.response.status);
      });
    },
    showNotification: function showNotification(status, modifier) {
      var resource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Checklist';

      return this.getMessage(notificationsMsg.byStatus(status, resource, modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19712600","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist/Show.vue
var Checklist_Show_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b-row',[_c('b-col',{attrs:{"sm":"7"}},[_c('strong',[_vm._v("Quick Report")])]),_c('b-col',{staticClass:"text-right",attrs:{"sm":"5"}},[(_vm.isAdmin)?[(_vm.checklist.revised)?[_c('b-button',{staticClass:"m-1 text-white",attrs:{"variant":"danger"},on:{"click":_vm.updateRevised}},[_c('i',{staticClass:"icon-dislike"}),_c('span',{staticClass:"pl-2"},[_vm._v("Cancel revision")])])]:[_c('b-button',{staticClass:"m-1 text-white",attrs:{"variant":"primary"},on:{"click":_vm.updateRevised}},[_c('i',{staticClass:"icon-like"}),_c('span',{staticClass:"pl-2"},[_vm._v("Revise the report")])])]]:[(_vm.checklist.revised)?_c('tempalte',[_c('i',{staticClass:"icon-like text-success font-weight-bold"}),_c('span',{staticClass:"p-2 text-success font-weight-bold"},[_vm._v("Revised report")])]):[_c('i',{staticClass:"icon-close text-danger font-weight-bold"}),_c('span',{staticClass:"p-2 text-danger font-weight-bold"},[_vm._v("Unrevised report")])]],_c('b-button',{staticClass:"m-1",attrs:{"variant":"primary"},on:{"click":_vm.generateQuickReport}},[_c('i',{staticClass:"icon-notebook"}),_c('span',{staticClass:"pl-2"},[_vm._v("Generate .pdf")])])],2)],1)],1),_c('b-row',{staticClass:"pb-2"},[_c('b-col',{attrs:{"sm":"10","xs":"9"}},[_c('p',[_vm._v("Q.I. Composites S.r.l. is approved as laboratory for technical competence in the field of Non-Destructive Testing for Range of approved test methods in the field of motor and sailing yachts & automotive by"),_c('strong',[_vm._v("Germanischer Lloyd")]),_vm._v("- Approval no. GL-LZ 2512 HH")])]),_c('b-col',{attrs:{"sm":"2","xs":"3"}},[_c('div',{staticClass:"quick-report-logo certificate-logo"})])],1),_c('b-row',{staticClass:"qr-separator-row"},[_c('b-col',{attrs:{"sm":"2","xs":"3"}},[_c('div',{staticClass:"quick-report-logo company-logo"})]),_c('b-col',{staticClass:"pt-2",attrs:{"sm":"10","xs":"9"}},[_c('h3',[_vm._v(_vm._s(_vm.checklist.name))]),_c('strong',{staticClass:"pr-2"},[_vm._v("Location:")]),_c('span',[_vm._v(_vm._s(_vm.checklist.location))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Reference project:")]),_c('span',[_vm._v(_vm._s(_vm.checklist.project.name))]),_c('br'),_c('strong',{staticClass:"pr-2"},[_vm._v("Object:")]),_c('span',[_vm._v(_vm._s(_vm.checklist.structure.card_name))])])],1)],1),_vm._l((_vm.checklist.checklist_items),function(item,index){return [_c('c-checklist-item',{attrs:{"index":index,"checklistItem":item}})]})],2)],1)}
var Checklist_Show_staticRenderFns = []
var Checklist_Show_esExports = { render: Checklist_Show_render, staticRenderFns: Checklist_Show_staticRenderFns }
/* harmony default export */ var components_Checklist_Show = (Checklist_Show_esExports);
// CONCATENATED MODULE: ./src/components/Checklist/Show.vue
function Checklist_Show_injectStyle (ssrContext) {
  __webpack_require__("2SYH")
}
var Checklist_Show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Checklist_Show___vue_template_functional__ = false
/* styles */
var Checklist_Show___vue_styles__ = Checklist_Show_injectStyle
/* scopeId */
var Checklist_Show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Checklist_Show___vue_module_identifier__ = null
var Checklist_Show_Component = Checklist_Show_normalizeComponent(
  Checklist_Show,
  components_Checklist_Show,
  Checklist_Show___vue_template_functional__,
  Checklist_Show___vue_styles__,
  Checklist_Show___vue_scopeId__,
  Checklist_Show___vue_module_identifier__
)

/* harmony default export */ var src_components_Checklist_Show = (Checklist_Show_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-form-wizard/dist/vue-form-wizard.js
var vue_form_wizard = __webpack_require__("3kHb");
var vue_form_wizard_default = /*#__PURE__*/__webpack_require__.n(vue_form_wizard);

// EXTERNAL MODULE: ./node_modules/vue-form-wizard/dist/vue-form-wizard.min.css
var vue_form_wizard_min = __webpack_require__("2+hT");
var vue_form_wizard_min_default = /*#__PURE__*/__webpack_require__.n(vue_form_wizard_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checklist/New.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var New = ({
  name: 'ChecklistNew',
  components: { Multiselect: vue_multiselect_min_default.a, FormWizard: vue_form_wizard["FormWizard"], TabContent: vue_form_wizard["TabContent"] },
  data: function data() {
    return {
      projectLoading: false,
      structuresLoading: false,
      isMultiple: true,
      projectsList: [],
      structuresList: [],
      currentProject: '',
      currentStructures: [],
      checklist: {
        name: '',
        location: '',
        date: '',
        batch_code: '',
        project_id: '',
        structure_ids: [],
        checklist_items: [{
          name: '',
          component_name: ''
        }]
      }
    };
  },

  props: {
    stepSize: {
      type: String,
      default: 'md',
      validator: function validator(value) {
        var acceptedValues = ['xs', 'sm', 'md', 'lg'];
        return acceptedValues.indexOf(value) !== -1;
      }
    }
  },
  watch: {
    currentProject: function currentProject(val, oldVal) {
      this.$set(this.$data, 'currentStructures', val.project_structures.map(function (obj) {
        return obj.structure;
      }));
      this.$set(this.$data, 'structuresList', val.project_structures.map(function (obj) {
        return obj.structure;
      }));
    }
  },
  methods: {
    getStructureIds: function getStructureIds(structures) {
      return structures.map(function (structure) {
        return structure.id;
      });
    },

    asyncFindProjects: lodash_default.a.debounce(function (query) {
      var _this = this;

      this.projectLoading = true;
      var url = apiRoutes.index('project');
      server.get(url, {
        params: {
          'q[name_cont]': query
        }
      }).then(function (res) {
        _this.$set(_this.$data, 'projectsList', res.data.projects);
        _this.projectLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this.projectLoading = false;
      });
    }, 700),
    addChecklistItem: function addChecklistItem() {
      this.checklist.checklist_items.push({
        name: '',
        component_name: ''
      });
    },
    removeChecklistItem: function removeChecklistItem(index) {
      this.checklist.checklist_items.splice(index, 1);
    },
    validateFirstStep: function validateFirstStep() {
      return this.$validator.validateAll();
    },
    submit: function submit() {
      if (!this.validateFirstStep) {
        this.errFirstStep();
      }
      this.saveChecklist(this.$route.params.id);
    },
    saveChecklist: function saveChecklist() {
      var _this2 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = 'checklists/batch'; // custom route, not use RouteGen
      var verb = 'post';
      var messageModifier = 'created';
      this.$data.checklist.project_id = this.$data.currentProject.id;
      this.$data.checklist.structure_ids = this.getStructureIds(this.$data.currentStructures);
      server[verb](url, { checklist: this.$data.checklist }).then(function (res) {
        _this2.showNotification(201, messageModifier);
        _this2.$router.push({ name: 'All inspections' });
      }).catch(function (err) {
        _this2.showNotification(err.response.status);
      });
    },
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Inspection', modifier));
    }
  },
  notifications: {
    getMessage: {},
    errFirstStep: {
      title: 'Inspection details',
      message: 'Incorrect informations',
      type: 'error'
    },
    errSecondStep: {
      title: 'To Do',
      message: 'Incorrect informations',
      type: 'error'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6545696","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist/New.vue
var New_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('form-wizard',{attrs:{"title":"Create a new Inspection","subtitle":"An inspection will be created for each object","nextButtonText":"Next","backButtonText":"Prev","finishButtonText":"Save","color":"#36a9e1","errorColor":"#ff5454","shape":"square"},on:{"submit":function($event){$event.preventDefault();_vm.submit($event)},"on-complete":function($event){_vm.submit()}}},[_c('tab-content',{attrs:{"title":"Inspection details","icon":"icon-settings","before-change":_vm.validateFirstStep}},[_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Inspection"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":"checklist_name","name":"name","placeholder":"Enter inspection's name"},model:{value:(_vm.checklist.name),callback:function ($$v) {_vm.$set(_vm.checklist, "name", $$v)},expression:"checklist.name"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('name')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Location"}},[_c('b-form-input',{attrs:{"type":"text","id":"checklist_location","name":"location","placeholder":"Enter location"},model:{value:(_vm.checklist.location),callback:function ($$v) {_vm.$set(_vm.checklist, "location", $$v)},expression:"checklist.location"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Date"}},[_c('b-form-input',{attrs:{"type":"date","id":"checklist_date","name":"date"},model:{value:(_vm.checklist.date),callback:function ($$v) {_vm.$set(_vm.checklist, "date", $$v)},expression:"checklist.date"}})],1)],1)],1),_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Project"}},[_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"checklist_project","name":"project","options":_vm.projectsList,"loading":_vm.projectLoading,"internal-search":false,"label":"name","close-on-select":true,"clear-on-select":true,"track-by":"id","placeholder":"Search a project here"},on:{"search-change":_vm.asyncFindProjects},model:{value:(_vm.currentProject),callback:function ($$v) {_vm.currentProject=$$v},expression:"currentProject"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('project')),expression:"errors.has('project')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('project')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Objects"}},[_c('multiselect',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"checklist_structures","name":"structures","multiple":_vm.isMultiple,"options":_vm.structuresList,"loading":_vm.structuresLoading,"internal-search":true,"label":"card_name","close-on-select":true,"track-by":"id","placeholder":"Search objects here"},model:{value:(_vm.currentStructures),callback:function ($$v) {_vm.currentStructures=$$v},expression:"currentStructures"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('structures')),expression:"errors.has('structures')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('structures')))])],1)],1)],1)],1)],1)],1),_c('tab-content',{attrs:{"title":"To do","icon":"icon-equalizer"}},[_vm._l((_vm.checklist.checklist_items),function(item,index){return [_c('b-card',[_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-fieldset',{attrs:{"label":"Part"}},[_c('b-form-input',{attrs:{"type":"text","id":"checklist_item_partundefined","name":"partundefined","placeholder":"Enter inspection-item's part"},model:{value:(item.name),callback:function ($$v) {_vm.$set(item, "name", $$v)},expression:"item.name"}})],1)],1),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-fieldset',{attrs:{"label":"ID"}},[_c('b-form-input',{attrs:{"type":"text","id":"checklist_item_component_nameundefined","name":"component_nameundefined","placeholder":"Enter component's ID"},model:{value:(item.component_name),callback:function ($$v) {_vm.$set(item, "component_name", $$v)},expression:"item.component_name"}})],1)],1),_c('b-col',{attrs:{"sm":"1"}},[_c('a',{on:{"click":function($event){_vm.removeChecklistItem(index)}}},[_c('i',{staticClass:"fa fa-minus-square-o fa-lg form__minus_btn text-danger"})])])],1)],1)]}),_c('b-col',{staticClass:"py-4 text-center",attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",on:{"click":_vm.addChecklistItem}},[_c('i',{staticClass:"fa fa-angle-double-down fa-lg px-2"}),_c('span',[_vm._v("Add inspection-item")]),_c('i',{staticClass:"fa fa-angle-double-down fa-lg px-2"})])])],2),_c('tab-content',{attrs:{"title":"Summary and confirmation","icon":"icon-check"}},[_c('b-card-group',{attrs:{"deck":"deck"}},[_c('b-card',[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v("Inspection")]),_c('p',[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v("Inspection:")]),_c('span',[_vm._v(_vm._s(_vm.checklist.name))])]),_c('p',[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v("Location:")]),_c('span',[_vm._v(_vm._s(_vm.checklist.location))])]),_c('p',[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v("Date:")]),_c('span',[_vm._v(_vm._s(_vm.checklist.date))])]),_c('p',[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v("Project:")]),_c('span',[_vm._v(_vm._s(_vm.currentProject.name))])]),_c('p',[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v("Objects:")]),_c('ul',_vm._l((_vm.currentStructures),function(structure){return _c('li',[_vm._v(_vm._s(structure.card_name))])}))])])],1),_c('b-card',[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v("Inspection-Items")]),_vm._l((_vm.checklist.checklist_items),function(item,index){return [_c('p',{staticClass:"mb-0"},[_c('span',{staticClass:"font-weight-bold pr-2"},[_vm._v(_vm._s(index+1)+". Part:")]),_c('span',[_vm._v(_vm._s(item.name))])]),_c('p',{staticClass:"mb-3"},[_c('span',{staticClass:"font-weight-bold px-3"},[_vm._v("Component ID:")]),_c('span',[_vm._v(_vm._s(item.component_name))])])]})],2)],1)],1)],1)],1)],1)],1)}
var New_staticRenderFns = []
var New_esExports = { render: New_render, staticRenderFns: New_staticRenderFns }
/* harmony default export */ var Checklist_New = (New_esExports);
// CONCATENATED MODULE: ./src/components/Checklist/New.vue
function New_injectStyle (ssrContext) {
  __webpack_require__("T1Fh")
}
var New_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var New___vue_template_functional__ = false
/* styles */
var New___vue_styles__ = New_injectStyle
/* scopeId */
var New___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var New___vue_module_identifier__ = null
var New_Component = New_normalizeComponent(
  New,
  Checklist_New,
  New___vue_template_functional__,
  New___vue_styles__,
  New___vue_scopeId__,
  New___vue_module_identifier__
)

/* harmony default export */ var components_Checklist_New = (New_Component.exports);

// EXTERNAL MODULE: ./node_modules/uppy/lib/core/Core.js
var Core = __webpack_require__("+p4S");
var Core_default = /*#__PURE__*/__webpack_require__.n(Core);

// EXTERNAL MODULE: ./node_modules/uppy/lib/plugins/Dashboard/index.js
var plugins_Dashboard = __webpack_require__("1xPc");
var Dashboard_default = /*#__PURE__*/__webpack_require__.n(plugins_Dashboard);

// EXTERNAL MODULE: ./node_modules/uppy/lib/plugins/AwsS3/index.js
var AwsS3 = __webpack_require__("SREN");
var AwsS3_default = /*#__PURE__*/__webpack_require__.n(AwsS3);

// EXTERNAL MODULE: ./node_modules/uppy/lib/plugins/FileInput.js
var FileInput = __webpack_require__("XJEk");
var FileInput_default = /*#__PURE__*/__webpack_require__.n(FileInput);

// EXTERNAL MODULE: ./node_modules/uppy/lib/plugins/StatusBar/index.js
var StatusBar = __webpack_require__("bhBy");
var StatusBar_default = /*#__PURE__*/__webpack_require__.n(StatusBar);

// EXTERNAL MODULE: ./node_modules/uppy/dist/uppy.css
var dist_uppy = __webpack_require__("x2No");
var uppy_default = /*#__PURE__*/__webpack_require__.n(dist_uppy);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Shared/Uppy.vue
//
//
//
//
//
//









/* harmony default export */ var Uppy = ({
  name: 'uppy',
  props: {
    uppyId: { type: String, default: null },
    uppySize: { type: Number, default: 3000000 },
    uppyProps: {
      type: Object,
      default: function _default() {
        return {
          dashboard: true,
          s3: true,
          input: false,
          statusBar: false
        };
      }
    },
    fileTypes: { type: Array, default: function _default() {
        return ['image/jpg', 'image/jpeg', 'image/png'];
      } }
  },
  mounted: function mounted() {
    var _this = this;

    var uppy = new Core_default.a({
      autoProceed: true,
      restrictions: {
        maxFileSize: this.uppySize,
        maxNumberOfFiles: 5,
        allowedFileTypes: false
      }
    });

    var usePlugins = function usePlugins() {
      if (_this.uppyProps.dashboard) {
        uppy.use(Dashboard_default.a, {
          inline: true,
          target: '.' + _this.uppyId,
          note: 'Max 5 files, up to 3 MB'
        });
      }

      if (_this.uppyProps.s3) {
        uppy.use(AwsS3_default.a, { getUploadParameters: _this.serverCall });
      }

      if (_this.uppyProps.input) {
        uppy.use(FileInput_default.a, {
          target: '.' + _this.uppyId
        });
      }
      if (_this.uppyProps.statusBar) {
        uppy.use(StatusBar_default.a, {
          target: '.uppybar-' + _this.uppyId
        });
      }
    };

    usePlugins();
    uppy.run();

    uppy.on('core:complete', function (files) {
      _this.$emit('on-success', files);
    });
  },

  methods: {
    serverCall: function serverCall(file) {
      return server.post('/presigned-puts', {
        filename: file.id + '.' + file.extension,
        content_type: file.type
      }).then(function (response) {
        return {
          method: response.data.method,
          url: response.data.url,
          fields: {}
        };
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395e59ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Uppy.vue
var Uppy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"uppy-component",class:_vm.uppyId}),(this.uppyProps.statusBar)?_c('div',{class:'uppybar uppybar-' + _vm.uppyId}):_vm._e()])}
var Uppy_staticRenderFns = []
var Uppy_esExports = { render: Uppy_render, staticRenderFns: Uppy_staticRenderFns }
/* harmony default export */ var Shared_Uppy = (Uppy_esExports);
// CONCATENATED MODULE: ./src/components/Shared/Uppy.vue
function Uppy_injectStyle (ssrContext) {
  __webpack_require__("n+fO")
}
var Uppy_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Uppy___vue_template_functional__ = false
/* styles */
var Uppy___vue_styles__ = Uppy_injectStyle
/* scopeId */
var Uppy___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Uppy___vue_module_identifier__ = null
var Uppy_Component = Uppy_normalizeComponent(
  Uppy,
  Shared_Uppy,
  Uppy___vue_template_functional__,
  Uppy___vue_styles__,
  Uppy___vue_scopeId__,
  Uppy___vue_module_identifier__
)

/* harmony default export */ var components_Shared_Uppy = (Uppy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checklist/subcomponents/EditItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ var EditItem = ({
  name: 'EditItem',
  components: { cUppy: components_Shared_Uppy, cSwitch: components_Shared_Switch },
  data: function data() {
    return {
      validations: {
        reportNumber: ''
      },
      uppyDoc: {
        dashboard: false,
        s3: true,
        input: true,
        statusBar: true
      },
      draftReportInfo: {
        notes: 'Allowed files: *.doc, *.docx, *.xls, *.xlsx, *.odt, *.ods',
        types: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/x-msi']
      },
      finalReportInfo: {
        notes: 'Allowed files: *.pdf',
        types: ['application/pdf']
      },
      item: {
        photo_urls: {}
      }
    };
  },

  props: {
    index: {
      type: Number,
      default: null
    },
    checklistItem: {
      type: Object,
      default: {}
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])({
    currentUser: 'currentUser'
  })),
  mounted: function mounted() {
    this.$set(this.$data, 'item', this.checklistItem);
    this.changeReportNumberRules();
  },

  watch: {
    item: function item() {
      this.$emit('update-item-data', { item: this.item, index: this.index });
    },
    draft_report: function draft_report() {
      this.changeReportNumberRules();
    }
  },
  methods: {
    itemColorVariant: function itemColorVariant() {
      if (this.item.defective) {
        return 'danger';
      }
      return 'primary';
    },
    canShowRemove: function canShowRemove() {
      if (!this.item.id) {
        return true;
      } else if (policeman.can('delete', 'checklistItem')) {
        return true;
      } else {
        return false;
      }
    },
    canUploadFinalReport: function canUploadFinalReport() {
      if (policeman.can('delete', 'checklistItem') && policeman.authorize(['admin'])) {
        return true;
      }
      return false;
    },
    changeReportNumberRules: function changeReportNumberRules() {
      if (this.item.draft_report) {
        if (this.item.draft_report.length) {
          this.$set(this.$data.validations, 'reportNumber', 'required');
        } else {
          this.$set(this.$data.validations, 'reportNumber', '');
        }
      }
    },
    canUploadDraftReport: function canUploadDraftReport() {
      if (policeman.can('edit', 'checklistItem')) {
        if (!this.item.checked || policeman.authorize(['admin'])) {
          return true;
        }
        var checkerEmail = this.item.checker.email;
        var checkerId = this.item.checker.id;
        if (this.currentUser.email === checkerEmail && this.currentUser.id === checkerId) {
          return true;
        }
      }
      return false;
    },
    isEdit: function isEdit() {
      return this.$route.params.hasOwnProperty('id');
    },
    handleCheckedChange: function handleCheckedChange(status) {
      this.$set(this.item, 'checked', status);
    },
    handleDefectiveChange: function handleDefectiveChange(status) {
      this.$set(this.item, 'defective', status);
    },
    setItemPhotos: function setItemPhotos(files) {
      var currentPhotos = this.$data.item.photos ? this.$data.item.photos : [];
      files.successful.map(function (file) {
        currentPhotos.push(file.id + '.' + file.extension);
      });
      this.$set(this.$data.item, 'photos', currentPhotos);
    },
    setItemDraftReport: function setItemDraftReport(draft) {
      this.$set(this.$data.item, 'draft_report', draft.successful[0].id + '.' + draft.successful[0].extension);
    },
    setItemFinalReport: function setItemFinalReport(final) {
      this.$set(this.$data.item, 'final_report', final.successful[0].id + '.' + final.successful[0].extension);
    },
    removeImg: function removeImg(key) {
      this.$delete(this.item.photo_urls, key);
      this.item.photos.splice(this.item.photos.indexOf(key), 1);
    },
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.saveItem(_this.item.id);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveItem: function saveItem() {
      var _this2 = this;

      var itemId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var checklistId = this.$route.params.id;
      var url = '/checklists/' + checklistId + '/checklist-items';
      var verb = 'post';
      var messageModifier = 'created';
      if (itemId) {
        url = apiRoutes.edit('checklist-item', itemId);
        verb = 'patch';
        messageModifier = 'updated';
      }

      server[verb](url, { checklist_item: this.$data.item }).then(function (res) {
        _this2.showNotification(201, messageModifier);
        _this2.$set(_this2.$data, 'item', res.data.checklist_item);
      }).catch(function (err) {
        _this2.showNotification(err.response.status);
      });
    },
    removeCurrentItem: function removeCurrentItem(index) {
      var _this3 = this;

      if (policeman.can('delete', 'checklistItem') || !this.item.id) {
        if (confirm('Do you want to delete this check?')) {
          if (this.item.id) {
            var url = apiRoutes.delete('checklist-item', this.item.id);
            var messageModifier = 'deleted';
            server.delete(url).then(function (res) {
              _this3.$emit('remove-checklist-item', index);
              _this3.showNotification(200, messageModifier);
            }).catch(function (err) {
              _this3.showNotification(err.response.status);
            });
          }
        }
      }
    },
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Inspection-item', modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bc2378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist/subcomponents/EditItem.vue
var EditItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion' + _vm.index),expression:"'accordion' + index"}],staticClass:"checklist-item-toggle text-left mt-3",attrs:{"block":"block","href":"#","variant":_vm.itemColorVariant()}},[_c('div',{staticClass:"item-status"},[(_vm.item.defective)?_c('small',[_vm._v("Defect")]):_vm._e()]),_c('span',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.item.name ? _vm.item.name : "New inspection-item"))]),_c('i',{staticClass:"icon-arrow-down accordion-icon"})]),_c('b-collapse',{attrs:{"id":'accordion' + _vm.index,"accordion":'accordion' + _vm.index,"role":"tabpanel"}},[_c('b-card',[_c('b-card-body',[_c('b-row',[_c('b-col',{staticClass:"item-delete text-right text-danger pb-4",attrs:{"sm":"12"}},[(_vm.canShowRemove())?[_c('a',{on:{"click":function($event){_vm.removeCurrentItem(_vm.index)}}},[_c('span',[_vm._v("REMOVE ITEM")]),_c('i',{staticClass:"icon-close pl-2"})])]:_vm._e()],2)],1),_c('b-row',[_c('b-col',{attrs:{"sm":"7"}},[_c('b-form-fieldset',{attrs:{"label":"Part"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":'checklist_item_part' + _vm.index,"name":'part' + _vm.index,"placeholder":"Enter inspection-item's part"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('item.name')),expression:"errors.has('item.name')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('item.name')))])],1)],1),_c('b-col',{attrs:{"sm":"5"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"ID"}},[_c('b-form-input',{attrs:{"type":"text","id":'checklist_item_component_name' + _vm.index,"name":'component_name' + _vm.index,"placeholder":"Enter component's ID"},model:{value:(_vm.item.component_name),callback:function ($$v) {_vm.$set(_vm.item, "component_name", $$v)},expression:"item.component_name"}})],1)],1)],1),(_vm.item.id)?_c('b-row',{staticClass:"pt-2"},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('c-switch',_vm._b({staticClass:"mr-3",attrs:{"type":"icon","variant":"danger","checked":_vm.item.defective},on:{"change":_vm.handleDefectiveChange}},'c-switch',{on: '', off: ''},false)),_c('span',[_vm._v("The component has defects")])],1)],1)],1)],1):_vm._e()],1)],1),(_vm.item.id)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Notes"}},[_c('b-form-textarea',{attrs:{"id":'checklist_item_notes' + _vm.index,"name":'notes' + _vm.index,"placeholder":"Write the notes here","rows":"5"},model:{value:(_vm.item.notes),callback:function ($$v) {_vm.$set(_vm.item, "notes", $$v)},expression:"item.notes"}})],1)],1)],1):_vm._e(),(_vm.item.id)?_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-fieldset',{attrs:{"label":"Grid of inspection"}},[_c('b-form-textarea',{attrs:{"id":'checklist_item_grid_of_inspection' + _vm.index,"name":'grid_of_inspection' + _vm.index,"placeholder":"Write the grid of inspection here","rows":"4"},model:{value:(_vm.item.grid_of_inspection),callback:function ($$v) {_vm.$set(_vm.item, "grid_of_inspection", $$v)},expression:"item.grid_of_inspection"}})],1)],1),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-fieldset',{attrs:{"label":"Instrumental settings"}},[_c('b-form-textarea',{attrs:{"id":'checklist_item_instrumental_settings' + _vm.index,"name":'instrumental_settings' + _vm.index,"placeholder":"Write the instrumental settings here","rows":"4"},model:{value:(_vm.item.instrumental_settings),callback:function ($$v) {_vm.$set(_vm.item, "instrumental_settings", $$v)},expression:"item.instrumental_settings"}})],1)],1)],1):_vm._e(),(_vm.item.id)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Photos"}},[_c('c-uppy',{attrs:{"uppyId":'uppy-' + _vm.index},on:{"on-success":_vm.setItemPhotos}})],1)],1)],1):_vm._e(),(_vm.item.id)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-container',{staticClass:"pb-4 pt-2 px-0",attrs:{"fluid":"fluid"}},[_c('b-row',[_vm._l((_vm.item.photo_urls),function(value,key){return [_c('b-col',{staticClass:"gallery-thumbnail",attrs:{"sm":"4"}},[_c('div',{staticClass:"gallery-thumbnail__element"},[_c('a',{attrs:{"href":value,"target":"_blank"}},[_c('b-img',{staticClass:"gallery-thumbnail__element__img",attrs:{"thumbnail":"thumbnail","fluid":"fluid","src":value}}),_c('i',{staticClass:"icon-eye gallery-thumbnail__element__icon"})],1)]),_c('div',{staticClass:"gallery-thumbnail__remove text-center my-2"},[_c('b-button',{attrs:{"type":"button","variant":"danger"},on:{"click":function($event){_vm.removeImg(key)}}},[_c('i',{staticClass:"icon-close pr-2"}),_c('span',[_vm._v("REMOVE")])])],1)])]})],2)],1)],1)],1):_vm._e(),(_vm.item.id)?_c('b-row',{staticClass:"py-3"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',{staticClass:"text-center"},[_vm._v("Reports")])])],1):_vm._e(),(_vm.item.id)?_c('b-row',{staticClass:"py-3"},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"6"}},[(_vm.canUploadDraftReport())?_c('b-form-fieldset',{attrs:{"label":"Draft Report"}},[_c('i',{staticClass:"small"},[_vm._v(_vm._s(_vm.draftReportInfo.notes))]),_c('c-uppy',{staticClass:"py-2",attrs:{"uppyProps":_vm.uppyDoc,"uppyId":'uppyDraft-' + _vm.index,"fileTypes":_vm.draftReportInfo.types,"uppySize":25000000},on:{"on-success":_vm.setItemDraftReport}}),(_vm.item.draft_report)?[_c('a',{staticClass:"report-link",attrs:{"href":_vm.item.draft_report_url}},[_c('strong',{staticClass:"text-success"},[_c('i',{staticClass:"icon-cloud-download pr-2"}),_c('span',[_vm._v("Download Draft report")])])])]:_vm._e()],2):_vm._e(),(!_vm.canUploadDraftReport())?_c('div',{staticClass:"text-danger"},[_c('b',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.item.checker.full_name + ' ' + _vm.item.checker.email))]),_c('p',[_vm._v("has already loaded a draft report")])]):_vm._e()],1),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6"}},[(_vm.canUploadFinalReport())?_c('b-form-fieldset',{attrs:{"label":"Final Report"}},[_c('i',{staticClass:"small"},[_vm._v(_vm._s(_vm.finalReportInfo.notes))]),_c('c-uppy',{staticClass:"py-2",attrs:{"uppyProps":_vm.uppyDoc,"uppyId":'uppyFinal-' + _vm.index,"fileTypes":_vm.finalReportInfo.types,"uppySize":25000000},on:{"on-success":_vm.setItemFinalReport}}),(_vm.item.final_report)?[_c('a',{staticClass:"report-link",attrs:{"href":_vm.item.final_report_url,"target":"_blank"}},[_c('strong',{staticClass:"text-success"},[_c('i',{staticClass:"icon-cloud-download pr-2"}),_c('span',[_vm._v("Download Final report")])])])]:_vm._e()],2):_vm._e(),(!_vm.canUploadFinalReport())?[_c('p',{staticClass:"text-danger"},[_vm._v("You can't upload a final report!")])]:_vm._e()],2)],1):_vm._e(),(_vm.item.id)?_c('b-row',{staticClass:"pt-2"},[(_vm.item.draft_report || _vm.item.final_report)?_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-fieldset',{attrs:{"label":"Report number"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.validations.reportNumber),expression:"validations.reportNumber"}],attrs:{"type":"text","id":'checklist_item_report_number' + _vm.index,"name":"report_number","placeholder":"Enter the report number"},model:{value:(_vm.item.report_number),callback:function ($$v) {_vm.$set(_vm.item, "report_number", $$v)},expression:"item.report_number"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('report_number')),expression:"errors.has('report_number')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('report_number')))])],1)],1):_vm._e(),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-fieldset',{attrs:{"label":"Completion date check"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"date","id":"checklistItem_checked_at","name":"checked_at","disabled":!_vm.canUploadDraftReport()},model:{value:(_vm.item.checked_at),callback:function ($$v) {_vm.$set(_vm.item, "checked_at", $$v)},expression:"item.checked_at"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('checked_at')),expression:"errors.has('checked_at')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('checked_at')))])],1)],1)],1):_vm._e(),_c('b-row',{staticClass:"py-2"},[_c('b-col',{attrs:{"sm":"3"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Save")])])],1)],1)],1)],1)],1)}
var EditItem_staticRenderFns = []
var EditItem_esExports = { render: EditItem_render, staticRenderFns: EditItem_staticRenderFns }
/* harmony default export */ var subcomponents_EditItem = (EditItem_esExports);
// CONCATENATED MODULE: ./src/components/Checklist/subcomponents/EditItem.vue
function EditItem_injectStyle (ssrContext) {
  __webpack_require__("5ZWw")
}
var EditItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditItem___vue_template_functional__ = false
/* styles */
var EditItem___vue_styles__ = EditItem_injectStyle
/* scopeId */
var EditItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditItem___vue_module_identifier__ = null
var EditItem_Component = EditItem_normalizeComponent(
  EditItem,
  subcomponents_EditItem,
  EditItem___vue_template_functional__,
  EditItem___vue_styles__,
  EditItem___vue_scopeId__,
  EditItem___vue_module_identifier__
)

/* harmony default export */ var Checklist_subcomponents_EditItem = (EditItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Checklist/Edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Edit = ({
  name: 'ChecklistEdit',
  components: { Multiselect: vue_multiselect_min_default.a, cChecklistItem: Checklist_subcomponents_EditItem },
  data: function data() {
    return {
      projectLoading: false,
      structuresLoading: false,
      checklist: {
        name: '',
        location: '',
        date: '',
        batch_code: '',
        project: {},
        structure: {
          card_name: ''
        },
        checklist_items: []
      }
    };
  },
  mounted: function mounted() {
    this.fetchChecklist(this.$route.params.id);
  },

  methods: {
    updateItemData: function updateItemData(item, index) {
      this.checklist.checklist_items[index] = item;
    },
    fetchChecklist: function fetchChecklist(checklistId) {
      var _this = this;

      var currentPermissions = this.$route.meta.roles;
      if (!policeman.authorize(currentPermissions)) {
        this.showNotification(401);
        this.$route.push({ name: 'Home' });
      }
      var route = apiRoutes.show('checklist', checklistId);
      server.get(route).then(function (res) {
        var checklist = res.data.checklist;
        _this.$set(_this.$data, 'checklist', checklist);
      }).catch(function (err) {
        console.log(err);
      });
    },

    asyncFindProjects: lodash_default.a.debounce(function (query) {
      var _this2 = this;

      this.projectLoading = true;
      var url = apiRoutes.index('project');
      server.get(url, {
        params: {
          'q[name_cont]': query
        }
      }).then(function (res) {
        _this2.$set(_this2.$data, 'projectsList', res.data.projects);
        _this2.projectLoading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.projectLoading = false;
      });
    }, 700),
    addChecklistItem: function addChecklistItem() {
      this.checklist.checklist_items.push({
        name: '',
        component_name: ''
      });
    },
    removeChecklistItem: function removeChecklistItem(index) {
      this.checklist.checklist_items.splice(index, 1);
      this.$set(this.$data.checklist, 'checklist_items', this.$data.checklist.checklist_items);
    },
    submit: function submit() {
      var _this3 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this3.saveChecklist(_this3.$route.params.id);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    saveChecklist: function saveChecklist() {
      var _this4 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var url = apiRoutes.edit('checklist', id);
      var messageModifier = 'updated';
      delete this.$data.checklist.batch_code; // if PATCH, batch_code is removed

      server.patch(url, { checklist: this.$data.checklist }).then(function (res) {
        _this4.showNotification(201, messageModifier);
        _this4.$router.push({ name: 'All inspections' });
      }).catch(function (err) {
        _this4.showNotification(err.response.status);
      });
    },
    showNotification: function showNotification(status, modifier) {
      return this.getMessage(notificationsMsg.byStatus(status, 'Inspection', modifier));
    }
  },
  notifications: {
    getMessage: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f36645b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist/Edit.vue
var Edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.submit($event)}}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Modify inspection's informations")]),_c('small',{staticClass:"pl-2"},[_vm._v("Form")])]),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Inspection"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"type":"text","id":"checklist_name","name":"name","placeholder":"Enter inspection's name"},model:{value:(_vm.checklist.name),callback:function ($$v) {_vm.$set(_vm.checklist, "name", $$v)},expression:"checklist.name"}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.errors.first('name')))])],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Location"}},[_c('b-form-input',{attrs:{"type":"text","id":"checklist_location","name":"location","placeholder":"Enter location"},model:{value:(_vm.checklist.location),callback:function ($$v) {_vm.$set(_vm.checklist, "location", $$v)},expression:"checklist.location"}})],1)],1),_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-fieldset',{attrs:{"label":"Date"}},[_c('b-form-input',{attrs:{"type":"date","id":"checklist_date","name":"date"},model:{value:(_vm.checklist.date),callback:function ($$v) {_vm.$set(_vm.checklist, "date", $$v)},expression:"checklist.date"}})],1)],1)],1),_c('b-col',{attrs:{"sm":"6"}},[_c('b-col',{staticClass:"pt-4",attrs:{"sm":"12"}},[_c('b-alert',{attrs:{"show":"show","variant":"primary"}},[_c('h5',[_vm._v("Project")]),_c('p',[_vm._v(_vm._s(_vm.checklist.project.name))])])],1),_c('b-col',{staticClass:"pt-2",attrs:{"sm":"12"}},[_c('b-alert',{attrs:{"show":"show","variant":"warning"}},[_c('h5',[_vm._v("Object")]),_c('p',[_vm._v(_vm._s(_vm.checklist.structure.card_name))])])],1)],1)],1),_c('b-col',{staticClass:"py-4",attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"submit"}},[_vm._v("Save")])])],1)],1),_vm._l((_vm.checklist.checklist_items),function(item,index){return [_c('c-checklist-item',{attrs:{"index":index,"checklistItem":item},on:{"update-item-data":_vm.updateItemData,"remove-checklist-item":_vm.removeChecklistItem}})]}),[_c('b-col',{staticClass:"py-4 text-center",attrs:{"sm":"12"}},[_c('button',{staticClass:"btn btn-primary px-4",attrs:{"type":"button"},on:{"click":_vm.addChecklistItem}},[_c('i',{staticClass:"fa fa-angle-double-down fa-lg px-2"}),_c('span',[_vm._v("Add inspection-item")]),_c('i',{staticClass:"fa fa-angle-double-down fa-lg px-2"})])])]],2)],1)}
var Edit_staticRenderFns = []
var Edit_esExports = { render: Edit_render, staticRenderFns: Edit_staticRenderFns }
/* harmony default export */ var Checklist_Edit = (Edit_esExports);
// CONCATENATED MODULE: ./src/components/Checklist/Edit.vue
var Edit_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Edit___vue_template_functional__ = false
/* styles */
var Edit___vue_styles__ = null
/* scopeId */
var Edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Edit___vue_module_identifier__ = null
var Edit_Component = Edit_normalizeComponent(
  Edit,
  Checklist_Edit,
  Edit___vue_template_functional__,
  Edit___vue_styles__,
  Edit___vue_scopeId__,
  Edit___vue_module_identifier__
)

/* harmony default export */ var components_Checklist_Edit = (Edit_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js




// Containers



// Dashboard views


// User views



// Project views




// Structure views




// Checklist views





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: src_containers_Full,
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: src_components_Dashboard,
      meta: {
        roles: policeman.getRoles('dashboard', 'index'),
        entity: 'dashboard'
      }
    }, { // user routes
      path: 'users',
      redirect: 'users/list',
      name: 'Users',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        roles: policeman.getRoles('user', 'index'),
        entity: 'user'
      },
      children: [{
        path: 'list',
        name: 'All users',
        component: components_User_Index,
        meta: {
          roles: policeman.getRoles('user', 'index'),
          entity: 'user'
        }
      }, {
        path: 'form',
        name: 'New user',
        component: components_User_Form,
        meta: {
          roles: policeman.getRoles('user', 'new'),
          entity: 'user'
        }
      }, {
        path: 'form/:id',
        name: 'Edit user',
        component: components_User_Form,
        meta: {
          roles: policeman.getRoles('user', 'edit'),
          entity: 'user'
        }
      }]
    }, { // project routes
      path: 'projects',
      redirect: 'projects/list',
      name: 'Projects',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        roles: policeman.getRoles('project', 'index'),
        entity: 'project'
      },
      children: [{
        path: 'list',
        name: 'All projects',
        component: src_components_Project_Index,
        meta: {
          roles: policeman.getRoles('project', 'index'),
          entity: 'project'
        }
      }, {
        path: 'form',
        name: 'New project',
        component: src_components_Project_Form,
        meta: {
          roles: policeman.getRoles('project', 'new'),
          entity: 'project'
        }
      }, {
        path: 'form/:id',
        name: 'Edit project',
        component: src_components_Project_Form,
        meta: {
          roles: policeman.getRoles('project', 'edit'),
          entity: 'project'
        }
      }, {
        path: ':id/objects_management',
        name: 'Project objects management',
        component: components_Project_StructuresManagement,
        meta: {
          roles: policeman.getRoles('project', 'edit'),
          entity: 'project'
        }
      }]
    }, { // structure routes (the user sees Objects)
      path: 'structures',
      redirect: 'structures/list',
      name: 'Objects',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        roles: policeman.getRoles('structure', 'index'),
        entity: 'structure'
      },
      children: [{
        path: 'list',
        name: 'All objects',
        component: src_components_Structure_Index,
        meta: {
          roles: policeman.getRoles('structure', 'index'),
          entity: 'structure'
        }
      }, {
        path: 'form',
        name: 'New object',
        component: src_components_Structure_Form,
        meta: {
          roles: policeman.getRoles('structure', 'new'),
          entity: 'structure'
        }
      }, {
        path: 'form/:id',
        name: 'Edit object',
        component: src_components_Structure_Form,
        meta: {
          roles: policeman.getRoles('structure', 'edit'),
          entity: 'structure'
        }
      }, {
        path: 'show/:id',
        name: 'Show object',
        component: components_Structure_Show,
        meta: {
          roles: policeman.getRoles('structure', 'show'),
          entity: 'structure'
        }
      }]
    }, { // checklist routes
      path: 'checklists',
      redirect: 'checklists/list',
      name: 'Inspections',
      component: {
        render: function render(c) {
          return c('router-view');
        }
      },
      meta: {
        roles: policeman.getRoles('checklist', 'index'),
        entity: 'checklist'
      },
      children: [{
        path: 'list',
        name: 'All inspections',
        component: src_components_Checklist_Index,
        meta: {
          roles: policeman.getRoles('checklist', 'index'),
          entity: 'checklist'
        }
      }, {
        path: 'form',
        name: 'New inspection',
        component: components_Checklist_New,
        meta: {
          roles: policeman.getRoles('checklist', 'new'),
          entity: 'checklist'
        }
      }, {
        path: 'form/:id',
        name: 'Edit inspection',
        component: components_Checklist_Edit,
        meta: {
          roles: policeman.getRoles('checklist', 'edit'),
          entity: 'checklist'
        }
      }, {
        path: 'report/:id',
        name: 'Show inspection',
        component: src_components_Checklist_Show,
        meta: {
          roles: policeman.getRoles('checklist', 'show'),
          entity: 'checklist'
        }
      }]
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: src_components_Login,
    meta: {
      requiresAuth: false
    }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.requiresAuth === false) {
    return next();
  }
  if (policeman.authorize(to.meta.roles)) {
    return next();
  } else {
    return next({ name: 'Login' });
  }
});


// EXTERNAL MODULE: ./node_modules/vue-notifications/dist/vue-notifications.es5.js
var vue_notifications_es5 = __webpack_require__("GB2M");
var vue_notifications_es5_default = /*#__PURE__*/__webpack_require__.n(vue_notifications_es5);

// EXTERNAL MODULE: ./node_modules/mini-toastr/dist/mini-toastr.es5.js
var mini_toastr_es5 = __webpack_require__("8aq0");
var mini_toastr_es5_default = /*#__PURE__*/__webpack_require__.n(mini_toastr_es5);

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("e0XP");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// EXTERNAL MODULE: ./node_modules/simple-line-icons/css/simple-line-icons.css
var simple_line_icons = __webpack_require__("FjQV");
var simple_line_icons_default = /*#__PURE__*/__webpack_require__.n(simple_line_icons);

// EXTERNAL MODULE: ./node_modules/vue-multiselect/dist/vue-multiselect.min.css
var dist_vue_multiselect_min = __webpack_require__("tLvy");
var dist_vue_multiselect_min_default = /*#__PURE__*/__webpack_require__.n(dist_vue_multiselect_min);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















singleton_default.a.config("https://4d5e46a641104ae5ac39a96758d1b26a@sentry.io/278449", { environment: "production", debug: false }).addPlugin(vue_default.a, vue_esm["a" /* default */]).install();

vue_esm["a" /* default */].use(es["a" /* default */]);

// --start-- vue-notifications with mini-toastr
var toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};
mini_toastr_es5_default.a.init({ types: toastTypes });

function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb;

  return mini_toastr_es5_default.a[type](message, title, timeout, cb);
}

var main_options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
vue_esm["a" /* default */].use(vue_notifications_es5_default.a, main_options);
vue_notifications_es5_default.a.config.timeout = 4000;
// --end-- vue-notifications with mini-toastr

// --start-- vee-validate
var main_config = {
  errorBagName: 'errors', // change if property conflicts
  fieldsBagName: 'vee-fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
};
vue_esm["a" /* default */].use(vee_validate_esm["a" /* default */], main_config);
// --end-- vee-validate

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "O7LI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QUmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/pagination/pagination.vue
//
//
//
//
//
//
//
//
//
//
//





var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }

  // Our render function is brought in from the pagination mixin
};/* harmony default export */ var pagination = ({
  mixins: [mixins["k" /* paginationMixin */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(num, evt) {
      var _this = this;

      // Handle edge cases where number of pages has changed (i.e. if perPage changes)
      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        // Keep the current button focused if possible
        var target = evt.target;
        if (Object(dom["m" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/pagination/pagination.vue
function injectStyle (ssrContext) {
  __webpack_require__("DHS7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  pagination,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pagination_pagination = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SsFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/index.js + 14 modules
var utils = __webpack_require__("sqiO");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/utils/dom.js
var dom = __webpack_require__("Kz7p");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/mixins/index.js + 14 modules
var mixins = __webpack_require__("+6kv");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-row.js
var form_row = __webpack_require__("I7Xz");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-text.js
var form_text = __webpack_require__("tDPY");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-invalid-feedback.js
var form_invalid_feedback = __webpack_require__("q32r");

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/form/form-valid-feedback.js
var form_valid_feedback = __webpack_require__("x7Qz");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/form-group/form-group.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var form_group = ({
    mixins: [mixins["i" /* idMixin */], mixins["h" /* formStateMixin */]],
    components: { bFormRow: form_row["a" /* default */], bFormText: form_text["a" /* default */], bFormInvalidFeedback: form_invalid_feedback["a" /* default */], bFormValidFeedback: form_valid_feedback["a" /* default */] },
    render: function render(h) {
        var t = this;
        var $slots = t.$slots;

        // Label
        var legend = h(false);
        if (t.label || $slots.label || t.horizontal) {
            legend = h('legend', { class: t.labelClasses, attrs: { id: t.labelId } }, [$slots.label || h('span', { domProps: { innerHTML: t.label || '' } })]);
        }

        // Invalid feeback text
        var invalidFeedback = h(false);
        if (t.feedback || $slots['invalid-feedback'] || $slots['feedback']) {
            invalidFeedback = h('b-form-invalid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback']),
                    expression: "Boolean(t.feedback || $slots['invalid-feedback'] || $slots['feedback'])"
                }],
                attrs: {
                    id: t.feedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === false ? $slots['invalid-feedback'] || $slots['feedback'] || h('span', { domProps: { innerHTML: t.feedback || '' } }) : h(false)]);
        }

        // Valid feeback text
        var validFeedback = h(false);
        if (t.validFeedback || $slots['valid-feedback']) {
            validFeedback = h('b-form-valid-feedback', {
                directives: [{
                    name: 'show',
                    rawName: 'v-show',
                    value: Boolean(t.validFeedback || $slots['valid-feedback']),
                    expression: "Boolean(t.validFeedback || $slots['valid-feedback'])"
                }],
                attrs: {
                    id: t.validFeedbackId,
                    role: 'alert',
                    'aria-live': 'assertive',
                    'aria-atomic': 'true'
                }
            }, [t.computedState === true ? $slots['valid-feedback'] || h('span', { domProps: { innerHTML: t.validFeedback || '' } }) : h(false)]);
        }

        // Form help text (description)
        var description = h(false);
        if (t.description || $slots['description']) {
            description = h('b-form-text', { attrs: { id: t.descriptionId } }, [$slots['description'] || h('span', { domProps: { innerHTML: t.description || '' } })]);
        }

        // Build layout
        var content = h('div', { ref: 'content', class: t.inputLayoutClasses }, [$slots.default, invalidFeedback, validFeedback, description]);

        // Generate fieldset wrapper
        return h('fieldset', {
            class: t.groupClasses,
            attrs: { id: t.safeId(), 'aria-describedby': t.describedByIds }
        }, [h('b-form-row', {}, [legend, content])]);
    },

    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
        labelCols: {
            type: Number,
            default: 3,
            validator: function validator(value) {
                if (value >= 1 && value <= 11) {
                    return true;
                }
                Object(utils["n" /* warn */])('b-form-group: label-cols must be a value between 1 and 11');
                return false;
            }
        },
        breakpoint: {
            type: String,
            default: 'sm'
        },
        labelTextAlign: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        labelSrOnly: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: null
        },
        feedback: {
            type: String,
            default: null
        },
        validFeedback: {
            type: String,
            default: null
        },
        validated: {
            type: Boolean,
            value: false
        }
    },
    computed: {
        inputState: function inputState() {
            return this.stateClass;
        },
        groupClasses: function groupClasses() {
            return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.inputState];
        },
        labelClasses: function labelClasses() {
            return [this.labelSrOnly ? 'sr-only' : 'col-form-legend', this.labelLayout, this.labelAlignClass];
        },
        labelLayout: function labelLayout() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : 'col-12';
        },
        labelAlignClass: function labelAlignClass() {
            if (this.labelSrOnly) {
                return null;
            }
            return this.labelTextAlign ? 'text-' + this.labelTextAlign : null;
        },
        inputLayoutClasses: function inputLayoutClasses() {
            return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - this.labelCols) : 'col-12'];
        },
        labelId: function labelId() {
            return this.label || this.$slots['label'] ? this.safeId('_BV_label_') : null;
        },
        descriptionId: function descriptionId() {
            if (this.description || this.$slots['description']) {
                return this.safeId('_BV_description_');
            }
            return null;
        },
        feedbackId: function feedbackId() {
            if (this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback']) {
                return this.safeId('_BV_feedback_invalid_');
            }
            return null;
        },
        validFeedbackId: function validFeedbackId() {
            if (this.validFeedback || this.$slots['valid-feedback']) {
                return this.safeId('_BV_feedback_valid_');
            }
            return null;
        },
        describedByIds: function describedByIds() {
            return [this.labelId, this.descriptionId, this.computedState === false ? this.feedbackId : null, this.computedState === true ? this.validFeedbackId : null].filter(function (i) {
                return i;
            }).join(' ') || null;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/form-group/form-group.vue
function injectStyle (ssrContext) {
  __webpack_require__("9JAL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_group,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var form_group_form_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1Fh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TGU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TseW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TxnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cYau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "gLfg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mhQR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n+fO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oDVn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qEor":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress-bar.js
var progress_bar = __webpack_require__("KpFv");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/bootstrap-vue/es/components/progress/progress.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var progress = ({
    components: { bProgressBar: progress_bar["a" /* default */] },
    render: function render(h) {
        var t = this;
        var childNodes = t.$slots.default;
        if (!childNodes) {
            childNodes = h('b-progress-bar', {
                props: {
                    value: t.value,
                    max: t.max,
                    precision: t.precision,
                    variant: t.variant,
                    animated: t.animated,
                    striped: t.striped,
                    showProgress: t.showProgress,
                    showValue: t.showValue
                }
            });
        }
        return h('div', { class: ['progress'], style: t.progressHeight }, [childNodes]);
    },

    props: {
        // These props can be inherited via the child b-progress-bar(s)
        variant: {
            type: String,
            default: null
        },
        striped: {
            type: Boolean,
            default: false
        },
        animated: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: null
        },
        precision: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        showValue: {
            type: Boolean,
            default: false
        },
        max: {
            type: Number,
            default: 100
        },
        // This prop is not inherited by child b-progress-bar(s)
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        progressHeight: function progressHeight() {
            return { height: this.height || null };
        }
    }
});
// CONCATENATED MODULE: ./node_modules/bootstrap-vue/es/components/progress/progress.vue
function injectStyle (ssrContext) {
  __webpack_require__("mhQR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  progress,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var progress_progress = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rdFu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w1yP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x2No":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.1da42501a1e3ef0f9f08.js